{
  "common": {
    "add": "添加",
    "all": "全部",
    "apply": "应用",
    "back": "返回",
    "batchCreate": "批量创建",
    "cancel": "取消",
    "clear": "清除",
    "clearAll": "清空",
    "close": "关闭",
    "columnValues": {
      "basicInfo": "基本信息",
      "bindTime": "绑定时间",
      "createBy": "创建人",
      "createTime": "创建时间",
      "description": "描述",
      "id": "ID",
      "operation": "操作",
      "remark": "备注",
      "status": "状态",
      "updateTime": "更新时间"
    },
    "confirm": "确认",
    "copy": "复制",
    "create": "创建",
    "delete": "删除",
    "detail": "详情",
    "dialogTitles": {
      "addTitle": "新增",
      "confirmDelete": "确认删除",
      "deleteTitle": "删除确认",
      "editTitle": "编辑",
      "reminder": "提示"
    },
    "export": "导出",
    "exportSuccess": "导出成功",
    "hide": "隐藏",
    "http": {
      "getLocaleFailed": "获取语言设置失败，使用默认语言:",
      "insufficientPermission": "权限不足，请重新登录",
      "loginExpired": "登录状态已过期，请重新登录",
      "requestFailed": "请求失败",
      "systemPrompt": "系统提示"
    },
    "inputPlaceholder": "请输入",
    "login": "登录",
    "loginOut": "退出系统",
    "messages": {
      "addFailed": "新增失败",
      "addSuccess": "新增成功",
      "deleteConfirm": "确定要删除吗？",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "editFailed": "编辑失败",
      "editSuccess": "编辑成功",
      "formValidationFailed": "表单验证失败",
      "imageUploadFailed": "图片上传失败",
      "imageUploadSuccess": "图片上传成功",
      "loginOutMessage": "确定要退出登录吗？",
      "operationFailed": "操作失败",
      "resetPasswordFailed": "密码重置失败",
      "resetPasswordSuccess": "密码重置成功",
      "saveFailed": "保存失败",
      "saveSuccess": "保存成功",
      "submitFailed": "提交失败",
      "updateFailed": "更新失败",
      "updateSuccess": "更新成功"
    },
    "no": "失败",
    "none": "无",
    "ok": "确定",
    "openInNewWindow": "在新页签中打开",
    "placeholders": {
      "enter": "请输入{field}",
      "search": "搜索{field}...",
      "select": "请选择{field}",
      "selectOrInput": "请选择或输入{field}"
    },
    "register": "注册",
    "reset": "重置",
    "save": "保存",
    "search": "搜索",
    "selectAll": "全选",
    "show": "显示",
    "statusValues": {
      "assignDevice": "已绑定设备",
      "assignQR": "已绑定QR",
      "binded": "已绑定",
      "bound": "绑定",
      "commandFailed": "下发失败",
      "commandProgress": "下发中",
      "commandSuc": "下发成功",
      "copyFailed": "复制失败",
      "copySuccess": "复制成功",
      "disabled": "禁用",
      "enabled": "启用",
      "error": "异常",
      "forbidden": "禁止",
      "no": "否",
      "noData": "暂无数据",
      "none": "无",
      "normal": "正常",
      "notSet": "未设置",
      "offline": "离线",
      "online": "在线",
      "processing": "处理中",
      "shipped": "已发货",
      "shippedFail": "发货失败",
      "unShipped": "未发货",
      "unbind": "未绑定",
      "unbound": "解绑",
      "unknown": "未知",
      "yes": "是"
    },
    "update": "更新",
    "timeZone": "时区",
    "validation": {
      "emailFormat": "请输入正确的邮箱地址",
      "hyphenRequired": "{field}需包含中划线(-)",
      "invalidLocale": "{field}格式无效，请输入合法的区域代码",
      "imageSizeLimit": "图片大小必须小于1MB",
      "lengthRange": "长度应在{min}到{max}个字符之间",
      "maxLength": "长度不能超过{max}个字符",
      "minLength": "长度必须至少{min}个字符",
      "onlyImageFiles": "仅允许上传图片文件",
      "passwordComplexity": "大小写字母、数字、特殊符号至少包含两种",
      "passwordMismatch": "两次输入的密码不一致",
      "required": "请输入{field}",
      "selectRequired": "请选择{field}",
      "urlFormat": "请输入有效的URL地址"
    },
    "version": "版本",
    "view": "查看",
    "viewDetail": "查看详情",
    "yes": "成功"
  },
  "dashboardPage": {
    "annualSalesComparison": "年度销售对比",
    "bottom5Performers": "后5名表现者",
    "bottom5WorstPerforming": "后5名最差表现",
    "cash": "现金",
    "cashVsCashless": "现金 vs 无现金收入",
    "cashless": "无现金",
    "cityMachineLocations": "城市机器位置",
    "clusterOffline": "该位置离线数量",
    "clusterOnline": "该位置在线数量",
    "day": "天",
    "displayBy": "显示方式",
    "errorMachines": "异常机器",
    "errorMachinesShort": "异常",
    "errorStatus": "异常",
    "hour": "小时",
    "income": "Income",
    "last12Months": "近12个月",
    "last24H": "近24小时",
    "last30Days": "近30日",
    "last7Days": "近7天",
    "last10Days": "近10天",
    "last10Mins": "近10分钟",
    "lastMonth": "上月",
    "lastPeriod": "Last Period",
    "lastUpdated": "最后更新",
    "lastWeek": "上周",
    "lastYear": "去年",
    "loadMachineMapFailed": "加载机器地图数据失败",
    "locationLabel": "位置",
    "machine": "机器",
    "machineNoLabel": "机器编号",
    "machinePrefix": "机器 #",
    "machines": "机构",
    "mapInfoOffline": "离线",
    "mapInfoOnline": "在线",
    "mapRetryLoad": "重试加载地图",
    "mapUnavailable": "地图暂不可用",
    "month": "月",
    "month1": "1月",
    "month10": "10月",
    "month11": "11月",
    "month12": "12月",
    "month2": "2月",
    "month3": "3月",
    "month4": "4月",
    "month5": "5月",
    "month6": "6月",
    "month7": "7月",
    "month8": "8月",
    "month9": "9月",
    "noMachineData": "暂无机器数据",
    "noPaymentData": "暂无支付数据",
    "officeBuildingA": "办公楼A",
    "offlineMachines": "离线机器",
    "onlineMachines": "在线机器",
    "onlineStatus": "在线",
    "paymentMethod": "支付方式",
    "paymentMethods": "支付方式",
    "revenue": "收入",
    "sales": "销售额",
    "salesTrendAnalysis": "销售趋势分析",
    "saltLakeCityArea": "盐湖城区域",
    "searchFilter": "搜索筛选",
    "searchMachines": "搜索机构...",
    "thisMonth": "本月",
    "thisWeek": "本周",
    "thisYear": "本年",
    "title": "仪表板",
    "today": "今天",
    "todayRevenue": "今日收入",
    "todayVends": "今日销量",
    "top5BestPerforming": "前5名最佳表现",
    "top5Performers": "前5名表现者",
    "totalSalesToday": "今日总收入",
    "totalVendsToday": "今日总销售",
    "vends": "Vends",
    "weekDay1": "周一",
    "weekDay2": "周二",
    "weekDay3": "周三",
    "weekDay4": "周四",
    "weekDay5": "周五",
    "weekDay6": "周六",
    "weekDay7": "周日",
    "weeklyComparison": "周对比",
    "year": "年",
    "yesterday": "昨天",
    "yesterdayRevenue": "昨日收入",
    "yesterdayVends": "昨日销量"
  },
  "developmentCenter": {
    "addApiKey": "新增API Key",
    "addGatewayConfig": "新增网关配置",
    "apiKeyCreatedSuccess": "API Key创建成功！\n密码：{password}",
    "apiKeyManagement": "OpenAPI Key管理",
    "apiName": "API名称",
    "apiNameLength": "API名称长度在 2 到 50 个字符",
    "confirmDeleteApiKey": "确定要删除 API Key {apiName} 吗？",
    "confirmDeleteGatewayConfig": "确定要删除机构 {orgName} 的网关配置吗？",
    "createSuccess": "创建成功",
    "deleteApiKeyFailed": "删除API Key失败",
    "deleteGatewayConfigFailed": "删除网关配置失败",
    "description": "OpenAPI网关配置和API Key管理",
    "editApiKey": "编辑API Key",
    "editGatewayConfig": "编辑网关配置",
    "enterApiName": "请输入API名称",
    "enterGatewayUrl": "请输入网关URL",
    "enterSignKey": "请输入签名密钥",
    "gatewayConfig": "OpenAPI网关配置",
    "gatewayType": "网关类型",
    "gatewayUrl": "网关URL",
    "help": {
      "apiName": "API Key的名称标识，用于在系统中识别和管理该API Key，长度2-50个字符",
      "apiSignKey": "签名密钥用于API请求的签名验证，确保请求的安全性和完整性，长度8-100个字符",
      "cstatus": "API Key状态，启用后该API Key才能正常使用，禁用后将无法进行API调用",
      "gatewayOrgId": "选择网关配置所属的机构，该机构将使用此网关配置进行API调用，创建后不可修改",
      "gatewayStatus": "网关配置状态，启用后该网关配置才能正常使用，禁用后将无法进行API调用",
      "gatewayType": "网关类型，选择API网关的类型，目前支持运营API类型",
      "gatewayUrl": "网关URL地址，用于API请求的路由和转发，必须是有效的URL格式",
      "orgId": "选择API Key所属的机构，该机构将拥有此API Key的使用权限，创建后不可修改"
    },
    "loadApiKeysFailed": "加载API Key失败",
    "loadGatewayConfigsFailed": "加载网关配置失败",
    "loadOrgTreeFailed": "加载机构树失败",
    "operational": "运营API",
    "operationalApi": "运营API",
    "orgCode": "机构编号",
    "orgType": "机构类型",
    "organization": "机构",
    "parentOrgNotFound": "找不到父机构 ID: {sid}，将机构 {label} 作为根节点",
    "pleaseEnterApiName": "请输入API名称",
    "pleaseEnterSignKey": "请输入签名密钥",
    "pleaseSelectOrg": "请选择所属机构",
    "pleaseSelectStatus": "请选择状态",
    "resetPassword": "重置密码",
    "resetPasswordFailed": "密码重置失败",
    "selectGatewayType": "请选择网关类型",
    "selectOrganization": "请选择机构",
    "selectStatus": "请选择状态",
    "signKey": "签名密钥",
    "signKeyLength": "签名密钥长度在 8 到 100 个字符",
    "signKeyTip": "签名密钥用于API请求的签名验证",
    "submitFailed": "提交失败",
    "title": "开发中心",
    "updateSuccess": "更新成功"
  },
  "error": {
    "mobileLayoutWarning": "移动端模式下不支持切换其它布局",
    "networkError": "抱歉，服务器报告错误。",
    "noPermission": "抱歉，您无权访问此页面。",
    "pageError": "抱歉，您访问的页面不存在。",
    "returnToHome": "返回首页"
  },
  "fileUpload": {
    "delete": "删除",
    "downloadFailed": "下载失败，请稍后重试",
    "downloadSuccess": "下载成功",
    "exampleDownload": "示例下载",
    "exampleDownloadBtnName": "设备批量导入范例.csv",
    "exampleDownloadTip": "下载示例文件，根据填写设备信息",
    "fileSizeLimit": "文件大小不能超过2MB！",
    "fileTip": "请上传Excel或CSV格式的文件，大小不超过2MB",
    "fileUpload": "文件上传",
    "invalidFileFormat": "无效的文件格式，请上传Excel或CSV文件！",
    "onlyExcelOrCsv": "只能上传Excel或CSV文件！",
    "selectFile": "选择文件"
  },
  "listFilter": {
    "cancel": "取消",
    "delete": "删除",
    "deletedColumns": "已删除的列",
    "exportFailed": "导出失败，请稍后重试",
    "noFilterItems": "暂无筛选项",
    "reset": "重置",
    "save": "保存",
    "saveFailed": "保存失败，请稍后重试",
    "saveSuccess": "保存成功",
    "selectedColumns": "已选择的列",
    "title": "列表筛选"
  },
  "lock": {
    "backToLogin": "返回登录",
    "entrySystem": "进入系统",
    "lockAction": "锁定",
    "lockPassword": "锁屏密码",
    "lockScreen": "锁定屏幕",
    "message": "锁屏密码错误",
    "placeholder": "请输入锁屏密码",
    "unlock": "点击解锁"
  },
  "loginPage": {
    "checkPassword": "确认密码",
    "code": "验证码",
    "copyright": "© 2026 Trilad Technology US LLC. 版权所有。",
    "continueWithApple": "使用Apple继续",
    "continueWithGoogle": "使用Google继续",
    "hasUser": "已有账号？去登录",
    "officialWebsite": "官网",
    "or": "或",
    "password": "密码",
    "remember": "记住我",
    "subtitle": "掌控您的机器宇宙",
    "username": "用户名"
  },
  "myAccount": {
    "accountInfo": "账户信息",
    "backupEmail": "备用邮箱",
    "basicInfo": "基本信息",
    "belongingOrg": "所属机构",
    "changePassword": "修改密码",
    "companyName": "公司名称",
    "confirmPwd": "确认新密码",
    "createBy": "创建人",
    "createTime": "创建时间",
    "currentTimeZone": "当前时区显示",
    "editPersonalProfile": "编辑个人资料",
    "editProfile": "编辑资料",
    "email": "邮箱",
    "enterCorrectMobile": "请输入正确的手机号",
    "firstName": "名字",
    "fullName": "姓名",
    "lastName": "姓氏",
    "lastUpdate": "最后更新",
    "loadUserInfoFailed": "加载用户信息失败",
    "loginAccount": "登录账号",
    "mobile": "手机号",
    "myProfile": "我的资料",
    "newPwd": "新密码",
    "notSet": "未设置",
    "oldPwd": "当前密码",
    "operatorName": "操作员名称",
    "passwordMismatch": "两次输入的密码不一致",
    "personalInfo": "个人信息",
    "preferences": "偏好设置",
    "preferencesTabDescription": "管理你的时区设置。",
    "profileTabDescription": "管理你的基础个人资料信息。",
    "profileUpdateSuccess": "个人资料更新成功",
    "pwdChangeFailed": "修改密码失败",
    "pwdChanged": "修改密码成功",
    "role": "角色",
    "security": "安全设置",
    "securityTabDescription": "更新你的登录密码。",
    "status": "状态",
    "language": "语言",
    "timeZone": "时区",
    "title": "我的账户",
    "titleLabel": "称谓",
    "updateFailed": "更新失败，请检查表单信息",
    "updateFailedMissingId": "更新失败，缺少操作员ID"
  },
  "operationManagement": {
    "agencyManagement": {
      "addAgency": "新增机构",
      "addSubAgency": "新增子机构",
      "agencyCode": "机构编号：",
      "agencyTypes": {
        "branchAgent": "分公司代理商",
        "customer": "客户",
        "factory": "工厂",
        "factoryAgent": "工厂代理商",
        "plat": "运营"
      },
      "basicInfoDetails": {
        "address": "地址",
        "agencyCode": "机构编号",
        "agencyLogo": "机构Logo",
        "agencyName": "机构名称",
        "agencyType": "机构类型",
        "contactEmail": "联系邮箱",
        "contactPerson": "联系人",
        "contactPhone": "联系电话",
        "country": "国家",
        "culture": "文化",
        "displayName": "显示名称",
        "email": "邮箱",
        "hasContract": "是否签署合同",
        "hasKyc": "是否KYC开户",
        "help": {
          "agencyLogo": "上传机构Logo，支持图片文件，建议尺寸40x40px，大小不超过2MB",
          "agencyName": "机构名称，用于标识机构，最大100个字符",
          "agencyType": "选择机构类型，不同机构类型有不同的业务规则和权限",
          "country": "选择机构所在国家，选择后会自动填充文化、语言和时区信息",
          "culture": "文化设置，根据选择的国家自动填充，用于数字和货币格式",
          "displayName": "显示名称，用于在前端界面展示机构名称，最大100个字符",
          "email": "机构联系邮箱，用于接收系统通知，需符合邮箱格式",
          "hasContract": "是否已签署合同，仅客户类型的机构需要填写",
          "hasKyc": "是否已完成KYC开户，仅客户类型的机构需要填写",
          "language": "语言设置，根据选择的国家自动填充，用于系统界面显示",
          "parentAgency": "选择上级机构，根据上级机构类型自动判断是否为总部",
          "status": "选择机构状态，禁用后该机构将无法正常使用",
          "taxRate": "商品税费率，范围0-100，支持两位小数，用于计算商品税费",
          "timezone": "时区设置，根据选择的国家自动填充，用于时间显示和计算"
        },
        "imageSizeLimit": "图片大小不能超过 1MB!",
        "isHeadquarters": "是否总部",
        "isHeadquartersTip": "（根据上级机构类型自动判断）",
        "language": "语言",
        "logoLoadFailed": "Logo加载失败",
        "logoTip": "支持图片文件上传，建议尺寸：40x40px",
        "logoUploadFailed": "Logo上传失败",
        "logoUploadSuccess": "Logo上传成功",
        "noLogo": "暂无Logo",
        "onlyImageFiles": "只能上传图片文件!",
        "parentAgency": "上级机构",
        "taxRate": "商品税费",
        "taxRateTip": "（单位：%，范围：0-100）",
        "timezone": "时区"
      },
      "deleteAgency": "删除机构",
      "editAgency": "编辑机构",
      "email": "邮箱：",
      "getOrgChildrenFailed": "加载下级机构列表失败",
      "getOrgDetailFailed": "获取机构详情失败",
      "getOrgTreeListFailed": "加载机构树列表失败",
      "messages": {
        "businessRules": {
          "addOperatorPasswordRequired": "新增操作员时密码不能为空",
          "branchAgentOnlyCustomerOrAgent": "分公司代理商底下只能创建客户或分公司代理商类型的机构",
          "customerOnlyCustomer": "客户底下只能创建客户类型的机构",
          "factoryAgentOnlyCustomerOrAgent": "工厂代理商底下只能创建客户或工厂代理商类型的机构",
          "factoryOnlyFactory": "工厂底下只能创建工厂类型的机构",
          "loadRolesFailed": "加载角色列表失败",
          "platMustBeHeadquarters": "运营机构必须是总部",
          "subAgencyCannotBeHeadquarters": "有上级机构的机构不能设置为总部"
        },
        "cannotDeleteWithChildren": "该机构下还有子机构，无法删除。请先删除所有子机构。",
        "confirmDeleteNoChildren": "确定要删除机构 \"{name}\" 吗？",
        "confirmDeleteOperator": "确定要删除操作员 \"{name}\" 吗？",
        "loadDataFailed": "加载数据失败",
        "loadingTree": "正在加载机构树..."
      },
      "operators": "操作员",
      "operatorsDetails": {
        "addOperator": "新增操作员",
        "adminRole": "管理员",
        "auditorRole": "审核员",
        "backupEmail": "备用邮箱",
        "companyName": "公司名称",
        "customerServiceRole": "客服",
        "editOperator": "编辑操作员",
        "emailLabel": "邮箱",
        "financeRole": "财务",
        "firstName": "名字",
        "help": {
          "backupEmail": "操作员的备用邮箱地址，用于紧急联系，需符合邮箱格式",
          "companyName": "操作员所属公司名称，最大200个字符",
          "email": "操作员的主要邮箱地址，用于接收系统通知，需符合邮箱格式",
          "firstName": "操作员的名字，最大50个字符",
          "lastName": "操作员的姓氏，最大50个字符",
          "loginAccount": "登录账号，用于系统登录，支持字母、数字与下划线，长度3-100个字符",
          "mobile": "操作员的手机号码，最大50个字符",
          "operatorName": "操作员显示名称，用于在系统中标识操作员，最大100个字符",
          "password": "登录密码，长度6-255个字符，建议使用字母、数字和特殊字符组合",
          "role": "选择操作员的角色，不同角色拥有不同的系统权限",
          "status": "选择操作员状态，禁用后该操作员将无法登录系统",
          "titleLabel": "操作员的职位或头衔，最大50个字符"
        },
        "lastName": "姓氏",
        "loginAccount": "登录账号",
        "mobile": "手机号",
        "operations": "操作",
        "operatorName": "操作员名称",
        "operatorRole": "操作员",
        "operatorsCreateTime": "创建时间",
        "operatorsDelete": "删除",
        "operatorsEdit": "编辑",
        "password": "密码",
        "passwordTip": "密码长度6-255个字符，建议使用字母、数字和特殊字符组合",
        "resetPassword": "重置密码",
        "role": "角色",
        "title": "操作员管理",
        "titleLabel": "称谓",
        "userType": "用户类型"
      },
      "payChannels": {
        "addChannelConfig": "新增渠道配置",
        "addToAgency": "添加到机构",
        "apiKeySecurityWarning": "您即将查看敏感的API密钥信息，请确认您的操作环境安全。",
        "availableChannels": "可添加到机构的支付渠道",
        "channelConfig": "渠道配置",
        "channelName": "渠道名称",
        "channelProducts": "渠道产品",
        "channelReferencedWarning": "该渠道被组合包引用，请先从包中移除后再删除",
        "configInfo": "配置信息",
        "configItemsIncomplete": "请填写完整的配置项信息",
        "configKeyDuplicate": "配置项键名不能重复",
        "configKeyPlaceholder": "配置键名",
        "configValuePlaceholder": "配置值",
        "configuredChannels": "机构已配置渠道",
        "currentConfiguredChannels": "当前机构已配置的支付渠道",
        "deleteConfirmMessage": "确定要删除这个渠道配置吗？删除后无法恢复。",
        "editChannelConfig": "编辑渠道配置",
        "formMode": "表单模式",
        "help": {
          "channelConfig": "配置支付渠道的参数，支持表单模式和JSON模式两种方式，根据渠道要求填写必填参数",
          "channelName": "支付渠道名称，由系统自动填充，不可修改",
          "mdrVatRate": "交易增值税费率，范围0-100，支持两位小数，用于计算交易增值税费",
          "mdrVatRateFixed": "交易增值固定税费，支持两位小数，用于计算交易增值固定税费",
          "status": "选择渠道状态，禁用后该渠道将无法使用"
        },
        "jsonConfigPlaceholder": "请输入JSON格式的配置...",
        "jsonFormatIncorrect": "JSON格式不正确",
        "jsonGenerateFailed": "JSON生成失败:",
        "jsonMode": "JSON模式",
        "jsonParseFailed": "JSON解析失败:",
        "loadOrgChannelsFailed": "加载机构支付渠道失败:",
        "loadSystemChannelsFailed": "加载系统渠道失败:",
        "mdrVatRate": "交易增值税费",
        "mdrVatRateFixed": "交易增值固定税费",
        "mdrVatRateTip": "（单位：%，范围：0-100）",
        "methodsCount": "种渠道",
        "noAvailableChannels": "暂无可添加的渠道",
        "noConfig": "暂无配置",
        "noConfigItems": "暂无配置项，点击上方按钮添加",
        "noConfiguredChannels": "暂未配置支付渠道，请从左侧选择添加",
        "noProducts": "暂无产品",
        "parseChannelConfigFailed": "解析渠道配置失败:",
        "searchNoResults": "搜索无结果，请尝试其他关键词",
        "searchPlaceholder": "搜索渠道名称或代码",
        "securityConfirm": "安全确认",
        "submitFormFailed": "提交表单失败:",
        "systemChannelPool": "系统渠道池",
        "toggleStatusConfirmMessage": "确定要{action}渠道\"{name}\"吗？",
        "toggleStatusConfirmTitle": "确认{action}",
        "toggleStatusSuccess": "{action}成功",
        "typeBoolean": "布尔值",
        "typeNumber": "数字",
        "typePlaceholder": "类型",
        "typeString": "字符串",
        "configWarningMsg": "配置信息中检测到连续多个星号，可能存在配置错误。是否继续提交？",
        "configWarningTitle": "配置可能有误"
      },
      "payChannelsTab": "支付渠道配置",
      "payMethods": {
        "addFailed": "添加失败",
        "addToAgency": "添加到机构",
        "availableMethods": "可添加到机构的支付方式",
        "configuredMethods": "机构已配置支付方式",
        "currentConfiguredMethods": "当前机构已启用的支付方式",
        "deleteConfirmMessage": "确定要删除这个支付方式配置吗？删除后无法恢复。",
        "methodReferencedWarning": "该支付方式被以下配置包引用，无法删除：",
        "noAvailableMethods": "暂无可添加的支付方式",
        "noConfiguredMethods": "暂未配置支付方式，请从左侧选择添加",
        "packageRefsCount": "个配置包引用",
        "searchNoResults": "搜索无结果，请尝试其他关键词",
        "searchPlaceholder": "搜索支付方式名称或代码",
        "systemPaymentMethods": "系统支付方式",
        "toggleStatusConfirmMessage": "确定要{action}支付方式\"{name}\"吗？",
        "toggleStatusConfirmTitle": "确认{action}",
        "toggleStatusSuccess": "{action}成功"
      },
      "payMethodsTab": "支付方式配置",
      "payPackages": {
        "addChannel": "添加渠道",
        "addChannelSuccess": "添加渠道成功",
        "addChannelToPackage": "添加渠道到包",
        "addMethod": "添加方式",
        "addMethodSuccess": "添加成功",
        "addPaymentMethod": "添加支付方式",
        "amount": "金额",
        "calculateFee": "计算费用",
        "calculationResult": "计算结果",
        "channelConfiguration": "渠道配置",
        "channelOperationFailed": "渠道操作失败",
        "channelPaymentMethodConfiguration": "渠道支付方式配置",
        "cloneFailed": "克隆失败",
        "cloneSuccess": "克隆成功",
        "createPackage": "新建包",
        "createPackageDialog": "新建配置包",
        "createSuccess": "创建成功",
        "currency": "币种",
        "currencyLoadFailed": "加载币种失败",
        "dataLoading": "数据加载中，请稍候...",
        "deleteChannelConfirm": "确定要删除这个渠道吗？删除后相关的支付方式配置也会被删除。",
        "deleteChannelFailed": "删除渠道失败",
        "deleteMethodConfirm": "确定要删除这个支付方式配置吗？",
        "deleteMethodFailed": "删除支付方式失败",
        "deletePackageConfirm": "确定要删除这个配置包吗？删除后无法恢复。",
        "device": "设备端",
        "editChannel": "编辑渠道",
        "editPackage": "编辑配置包",
        "editPaymentMethod": "编辑支付方式",
        "feePreview": "费用预览",
        "fixedFee": "固定费",
        "fixedFeeCannotBeNegative": "固定费用不能小于0",
        "fixedRate": "固定费率",
        "handlingFee": "手续费",
        "help": {
          "currency": "选择配置包支持的币种，该币种将应用于包内所有渠道和支付方式",
          "fixedFee": "固定费用，范围≥0，每笔交易固定收取的手续费",
          "maxAmount": "配置包允许的最大交易金额，绑定该支付包的机器价格不能超过此金额",
          "minAmount": "配置包允许的最小交易金额，绑定该支付包的机器价格不能低于此金额",
          "packageName": "配置包的名称，用于标识该配置包，最大100个字符",
          "packageType": "选择配置包类型，设备端用于设备支付场景，开放API用于API接口调用场景",
          "paymentMethod": "选择支付方式，仅显示当前渠道支持的支付方式",
          "platProduct": "选择关联的平台业务产品，选择后将限制只能添加该产品关联的渠道，设备端类型必填",
          "ratePercentage": "百分比费率，范围0-99.99，按交易金额的百分比计算手续费",
          "selectChannel": "从已配置的机构支付渠道中选择要添加到配置包的渠道，可多选",
          "status": "选择配置包状态，禁用后该配置包将无法使用"
        },
        "amountCannotBeNegative": "金额不能小于0",
        "maxAmount": "最大金额",
        "maxAmountCannotBeLessThanMin": "最大金额不能小于最小金额",
        "minAmount": "最小金额",
        "minAmountCannotExceedMax": "最小金额不能大于最大金额",
        "loadChannelMethodsFailed": "加载渠道支付方式失败",
        "loadChannelsFailed": "加载渠道失败",
        "loadCurrenciesFailed": "加载币种失败",
        "loadMethodsFailed": "加载支付方式失败",
        "loadPackageChannelsFailed": "加载套餐渠道失败",
        "loadPackageMethodsFailed": "加载套餐方式失败",
        "loadPackagesFailed": "加载配置包失败",
        "methodFormRefNotFound": "表单引用不存在",
        "methodOperationFailed": "支付方式操作失败",
        "noAvailableChannels": "暂无可添加的渠道，请先配置机构支付渠道",
        "noChannelConfiguration": "暂无渠道配置",
        "noChannelsInPackage": "该配置包暂无渠道，请点击添加渠道",
        "noMethodsInChannel": "该渠道暂无支付方式，请点击添加方式",
        "noPackages": "暂无配置包，请点击新建包",
        "noPaymentMethodConfiguration": "暂无支付方式配置",
        "noPaymentMethodsInChannel": "该渠道下没有配置支付方式",
        "openApi": "开放API",
        "packageChannelConfiguration": "包内渠道配置",
        "packageCode": "包编码",
        "packageName": "包名称",
        "packagePreview": "配置包预览",
        "packageType": "包类型",
        "paymentConfigurationPackages": "支付配置包",
        "paymentMethod": "支付方式",
        "paymentMethodConfiguration": "支付方式配置",
        "percentageRate": "百分比费率",
        "pleaseSelectChannel": "请选择一个渠道",
        "pleaseSelectChannelFirst": "请先选择一个渠道",
        "pleaseSelectPackage": "请选择一个配置包",
        "pleaseSelectPackageAndChannel": "请先选择配置包和渠道",
        "pleaseSelectPackageFirst": "请先选择配置包",
        "ratePercentage": "费率(%)",
        "rateRange": "费率必须在0-99.99之间",
        "saveChannelFailed": "保存渠道失败",
        "saveFailed": "保存失败",
        "saveMethodFailed": "保存支付方式失败",
        "savePackageFailed": "保存配置包失败",
        "selectAtLeastOneChannel": "请选择至少一个渠道",
        "selectChannel": "选择渠道",
        "selectPackageType": "请选择包类型",
        "updateChannelSuccess": "更新渠道成功",
        "updateMethodSuccess": "更新成功",
        "updateSuccess": "更新成功",
        "yourReceive": "您将收到"
      },
      "payPackagesTab": "支付配置包",
      "resetPasswordDetails": {
        "confirmPassword": "确认密码",
        "newPassword": "新密码",
        "operator": "操作员",
        "resetPasswordOperator": "操作员",
        "title": "重置密码"
      },
      "searchAgency": "搜索机构...",
      "selectAgencyToView": "请先选择左侧机构查看详情",
      "title": "机构管理"
    },
    "machineTransferLog": {
      "endTime": "结束时间",
      "enterOperator": "请输入操作员",
      "enterSysMachineNo": "请输入系统机器编号",
      "loadDataFailed": "加载数据失败",
      "loadOrgTreeFailed": "加载机构树失败",
      "machineInfo": "机器信息",
      "machineName": "机器名称",
      "machineType": "机器类型",
      "newOrg": "新机构",
      "noErrorMessage": "无失败原因",
      "oldOrg": "原机构",
      "operateTime": "操作时间",
      "operator": "操作员",
      "orgChange": "机构变更",
      "orgMachineNoChange": "机构机器编号变更",
      "selectEndTime": "请选择结束时间",
      "selectNewOrg": "请选择新机构",
      "selectOldOrg": "请选择原机构",
      "selectStartTime": "请选择开始时间",
      "startTime": "开始时间",
      "sysMachineNo": "系统机器编号",
      "title": "机器流转记录",
      "transferReason": "转移原因",
      "transferResult": "转移结果"
    },
    "operationMachineManagement": {
      "welcome": {
        "title": "探索你的星系，管理你的机器",
        "selectOperator": "从左侧面板选择机构（星系），查看其下属机构和机器。",
        "selectMachine": "点击机器查看详情并配置设置。",
        "alternative": "你也可以",
        "createMachine": "创建新机器"
      },
      "accessLogTitle": "禁能日志",
      "accessStatus": "禁能状态",
      "accessStatusIdle": "空闲",
      "accessStatusPlaying": "禁止",
      "activeTime": "激活时间(ms)",
      "addCurrencySymbol": "添加货币符号",
      "addDeviceFailed": "添加机器失败",
      "addFavoriteFailed": "收藏失败",
      "addFavoriteSuccess": "收藏成功",
      "addMachine": "新增机器",
      "addMachineFailed": "新增机器失败",
      "addMachineFavoriteFailed": "新增机器收藏失败",
      "addMachineFavoriteSuccess": "新增机器收藏成功",
      "addMachineProtocolConfigFailed": "新增机器协议配置失败",
      "addMachineProtocolConfigSuccess": "新增机器协议配置成功",
      "addMachineSuccess": "新增机器成功",
      "addMachineTransferLogFailed": "新增机器转移日志失败",
      "addMachineTransferLogSuccess": "新增机器转移日志成功",
      "addPrice": "添加价格",
      "addPriceDisabledTip": "需要先把价格1填写完整",
      "addProtocol": "新增协议",
      "addProtocolConfig": "新增协议配置",
      "addTransfer": "转移机器",
      "animationDuration": "动画播放时长",
      "animationPreview": "动画预览",
      "averageUnitPrice": "平均单价",
      "basicConfig": "基本配置",
      "basicTextSettings": "基础文本设置",
      "belongingOrg": "所属机构",
      "bindDevice": "绑定设备",
      "bindFailed": "绑定失败",
      "bindQr": "绑定二维码",
      "bindSuccess": "绑定成功",
      "bound": "已绑定",
      "boundDevice": "绑定设备",
      "viewDevice": "查看设备",
      "boundQrCode": "绑定二维码",
      "cancelFavoriteFailed": "取消收藏失败",
      "cancelFavoriteSuccess": "取消收藏成功",
      "cannotFindFavoriteRecord": "无法找到收藏记录",
      "cannotGetDeviceId": "无法获取设备ID",
      "cannotGetDeviceInfo": "无法获取设备信息",
      "cannotGetMachineId": "无法获取机器ID",
      "cannotGetMachineNo": "无法获取机器编号",
      "cashAmount": "现金金额",
      "cashClearLog": "现金清零记录",
      "cashHandling": "现金处理",
      "cashLog": "记录",
      "cci": "CCI",
      "cciProtocol": "CCI协议",
      "checkDeviceStatusFailed": "查询设备状态失败，请稍后重试",
      "china": "中国",
      "choosePaymentMethod": "选择支付方式",
      "choosePaymethodTitle": "选择支付方式文本",
      "choosePlanText": "选择计划文本",
      "providerName": "支付服务商",
      "selectProviderName": "请选择支付服务商",
      "chooseProgram": "Choose Program",
      "chooseProgramTitle": "选择程序标题",
      "city": "城市",
      "clearAmount": "清零金额",
      "clearCash": "清零",
      "clearCashFailed": "现金清零失败",
      "clearCashSuccess": "现金清零成功",
      "clearTime": "清零时间",
      "cashProduct": "现金商品",
      "cashProductHint": "现金交易上报展示名称",
      "coinCount": "硬币数量(个)",
      "coinValue": "硬币面值",
      "collapse": "折叠",
      "completed": "已完成",
      "configSummary": "配置摘要",
      "confirmCancelFavorite": "确认取消收藏",
      "confirmCancelFavoritePrompt": "确定要取消收藏机器{name}吗？",
      "confirmClearCash": "确认清零",
      "confirmClearCashMessage": "确定要清零现金金额 {amount} 吗？此操作不可撤销。",
      "confirmDelete": "确认删除",
      "confirmDeleteTransferPrompt": "确定要删除这个转移记录吗？",
      "confirmRemoveFavorite": "确认取消收藏",
      "confirmRemoveFavoriteMessage": "确定要取消收藏机器\"{machineName}\"吗？",
      "confirmUnbindDevice": "确认解绑设备",
      "confirmUnbindDeviceMessage": "请确认您是否要将设备 \"{deviceSN}\" 从机器 \"{machineName}{machineNumber}\"解绑。",
      "copy": "复制",
      "copyFailed": "复制失败",
      "copySuccess": "复制成功",
      "country": "国家",
      "createBy": "创建人",
      "currentFrame": "当前帧",
      "deleteFailed": "删除失败",
      "deleteMachineFailed": "删除机器失败",
      "deleteMachineFavoriteFailed": "删除机器收藏失败",
      "deleteMachineFavoriteSuccess": "删除机器收藏成功",
      "deleteMachineProtocolConfigFailed": "删除机器协议配置失败",
      "deleteMachineProtocolConfigSuccess": "删除机器协议配置成功",
      "deleteMachineSuccess": "删除机器成功",
      "deleteMachineTransferLogFailed": "删除机器转移日志失败",
      "deleteMachineTransferLogSuccess": "删除机器转移日志成功",
      "deleteProtocol": "删除协议",
      "deleteProtocolConfirm": "确定要删除协议 \"{name}\" 吗？",
      "deleteSuccess": "删除成功",
      "paymentSimulationMode": "支付模拟模式",
      "paymentSimulationModeDesc": "选择在演示模式下如何为该机器模拟支付。",
      "paymentSimulationModeManualTitle": "手动扫码支付模拟",
      "paymentSimulationModeManualDesc": "用户可在终端获取动态二维码，使用手机扫码打开Trilad收银台模拟页面并按下 Pay 按钮在手机端确认支付。",
      "paymentSimulationModeAutoTitle": "自动支付模拟",
      "paymentSimulationModeAutoDesc": "倒计时结束后自动模拟支付成功，无需手机交互。",
      "detailedLocation": "详细位置",
      "detectionMethod": "检测方式",
      "detectionNone": "无",
      "detectionPulse": "脉冲",
      "deviceCount": "机器数量",
      "deviceCreateSuccess": "机器创建成功",
      "deviceName": "设备名称",
      "deviceNotBound": "设备未绑定，无法执行免费出货操作",
      "deviceOffline": "设备离线，无法执行出货操作",
      "deviceProtocolConfig": "机器协议配置",
      "deviceSn": "设备SN",
      "deviceStatusForbidden": "机器状态已设置为禁止，该机器将无法进行支付操作",
      "deviceStatusNormal": "机器状态已恢复正常",
      "deviceType": "设备类型",
      "deviceUpdateSuccess": "机器更新成功",
      "dictItemNotFound": "未找到对应的字典项",
      "discountAmount": "折扣金额",
      "discountRate": "优惠比例(%)",
      "displayBasePrice": "显示基础价格",
      "editMachine": "编辑机器",
      "editMachineFavoriteFailed": "编辑机器收藏失败",
      "editMachineFavoriteSuccess": "编辑机器收藏成功",
      "editMachineProtocolConfigFailed": "编辑机器协议配置失败",
      "editMachineProtocolConfigSuccess": "编辑机器协议配置成功",
      "editMachineTransferLogFailed": "编辑机器转移日志失败",
      "editMachineTransferLogSuccess": "编辑机器转移日志成功",
      "editProtocolConfig": "编辑协议配置",
      "email": "邮箱",
      "enableTimeout": "启用超时设置",
      "enterChoosePaymethodTitle": "请输入选择支付方式文本",
      "enterChoosePlanText": "请输入选择计划文本",
      "enterChooseProgramTitle": "请输入选择程序标题",
      "enterDeviceSn": "请输入设备SN",
      "enterDeviceSnOrQrCode": "请输入设备SN或二维码编号",
      "enterOrgNo": "请输入机构号",
      "enterQrCodeNo": "请输入二维码编码",
      "enterResultDescription": "请输入结果页描述",
      "enterResultTitle": "请输入结果页标题",
      "enterSinglePriceGoodsNameText": "请输入单价格下商品名称文本",
      "enterSinglePriceGoodsUnitText": "请输入单价格下商品单位",
      "enterTransferRemark": "请输入转移备注",
      "errorMessage": "失败原因",
      "expand": "展开",
      "favoriteFailed": "收藏失败",
      "favoriteMachines": "收藏的机器",
      "favoriteRecordNotFound": "无法找到收藏记录",
      "favoriteSuccess": "收藏成功",
      "fixedAmount": "固定金额",
      "fixedRateNotNegative": "固定费率不能为负数",
      "freeVend": "免费出货",
      "freeVendTooltip": "远程分发物品，不向用户收费",
      "fromOrg": "来源机构",
      "generateQrCodeImageFailed": "生成二维码图片失败",
      "generateQrCodeLinkFailed": "生成二维码链接失败",
      "getDiscounts": "获取折扣",
      "gift": "赠品",
      "goLive": "切换到生产",
      "goodsImage": "商品图片",
      "help": {
        "addCurrencySymbol": "是否在价格显示中添加货币符号",
        "animationDuration": "动画持续时间，范围1-10秒，控制动画播放的时长",
        "belongingOrg": "选择机器所属的机构，创建后不可修改",
        "choosePaymethodTitle": "选择支付方式文本，显示在支付方式选择区域的标题文字",
        "choosePlanText": "选择计划文本，用于在终端设备上显示",
        "providerName": "终端支付服务商（BrePay / MercadoPago），随基础配置下发为 provider.name",
        "chooseProgramTitle": "选择程序标题，显示在价格选择区域的标题文字",
        "city": "机器所在的城市",
        "cashProduct": "现金订单商品名称，仅保存到机器协议配置，不下发到设备",
        "coinCount": "硬币数量，范围1-999个，用于计算脉冲数的基准",
        "coinValue": "硬币面值，范围0.01-999，单位与币种一致",
        "country": "机器所在的国家",
        "detailedLocation": "机器的详细地址信息",
        "detectionMethod": "检测方式，无表示不检测，脉冲表示通过脉冲信号检测",
        "deviceSn": "设备的序列号，用于标识和绑定物理设备",
        "enableTimeout": "是否启用超时设置，启用后可配置超时时长和检测方式",
        "indexGoodsImg": "首页商品图片，显示在首页商品区域的图片",
        "locationInfo": "机器的位置信息，包括国家、城市和详细地址",
        "machineImage": "上传机器的主图片，支持jpg/png格式，大小不超过2MB",
        "machineName": "机器的显示名称，用于在系统中标识机器，长度2-50个字符",
        "machineNumber": "机器的唯一编号，用于标识该机器，创建后不可修改",
        "machineTags": "为机器添加标签，可用于分类和筛选，支持创建新标签",
        "machineType": "选择机器的类型，不同类型有不同的业务规则和功能",
        "orgNo": "请输入目标机构的机构号",
        "orgPaymentPackage": "选择机构支付配置包，该包决定了机器可用的支付渠道和支付方式",
        "preAnimationGifs": "支付成功前动画图片，显示在支付成功前的动画图片",
        "preAnimationStaticImg": "支付成功前静态图片，显示在支付成功前的静态图片",
        "priceText": "价格文本，用于显示在价格选择区域的自定义文字",
        "priceYuan": "价格，范围≥0，支持两位小数；若机器绑定了支付包，还需满足支付包的最小{min}/最大{max}金额限制",
        "protocolCode": "选择协议类型，不同协议有不同的配置选项和功能",
        "pulseActive": "脉冲激活时长，单位为毫秒，默认100ms",
        "pulseActiveTime": "脉冲激活时间，范围1-9999毫秒，控制脉冲信号的持续时间",
        "pulseActiveTip": "脉冲激活时长，单位为毫秒，默认100ms",
        "pulseCount": "脉冲数量，范围1-9999，必须是硬币数量的倍数",
        "pulseInactive": "脉冲非激活时长，单位为毫秒，默认100ms",
        "pulseInactiveTime": "脉冲非激活时间，范围1-9999毫秒，控制脉冲信号的间隔时间",
        "pulseInactiveTip": "脉冲非激活时长，单位为毫秒，默认100ms",
        "pulseUnit": "多少脉冲上送一次，默认1",
        "qrCodeNo": "二维码编号，用于绑定支付二维码到机器",
        "quantity": "数量，范围1-999个，表示该价格对应的商品数量",
        "remark": "机器的备注信息，用于记录额外的说明或备注",
        "resultAnimationGifs": "支付成功后动画图片，显示在支付成功后的动画图片",
        "resultAnimationStaticImg": "支付成功后静态图片，显示在支付成功后的静态图片",
        "resultDescription": "结果页描述，显示在支付成功的页面描述文字",
        "resultTitle": "结果页标题，显示在支付成功的页面标题",
        "sceneType": "选择场景类型，不同场景有不同的显示选项和功能",
        "selectProduct": "选择要免费出货的产品，从已配置的脉冲协议价格中选择",
        "serviceFeeRate": "服务费率，百分比类型范围0-100，固定金额类型范围≥0",
        "serviceFeeType": "选择服务费类型，百分比按交易金额的百分比计算，固定金额为每笔交易固定费用",
        "showInsertedCoin": "是否显示投入硬币数量",
        "singlePriceGoodsNameText": "单价格下商品名称文本，显示在单价格模式下的商品名称",
        "singlePriceGoodsUnitText": "单价格下商品单位，显示在单价格模式下的商品单位",
        "status": "选择机器状态，禁用后该机器将无法进行支付操作",
        "supportOnlinePayment": "开启后机器将支持线上支付功能",
        "taxRate": "税率，范围0-100%，按百分比计算税费",
        "theme": "选择终端页面主题风格，用于控制支付页面的视觉样式",
        "timeoutDuration": "超时时长，范围1-300秒，超过此时长将触发超时处理",
        "timeoutNonCash": "出货超时后是否允许非现金交易",
        "toOrg": "选择目标机构，机器将被转移到该机构下",
        "transferMode": "选择转移机器的方式",
        "transferReason": "转移原因，说明机器转移的理由，最大200个字符"
      },
      "imageSizeLimit": "图片大小不能超过1MB",
      "imageUploadFailed": "图片上传失败",
      "imageUploadSuccess": "图片上传成功",
      "imageUploadTip": "只能上传jpg/png文件，且不超过2MB",
      "inactiveTime": "非激活时间(ms)",
      "indexGoodsImg": "首页商品图",
      "indexGoodsImgSettings": "首屏商品图设置",
      "invalidProduct": "选择的产品无效",
      "isBindDevice": "设备关联状态",
      "isBindQr": "二维码关联状态",
      "isGoodsCollapsible": "折叠显示商品",
      "jvma": "JVMA",
      "jvmaProtocol": "JVMA协议",
      "loadAccessLogFailed": "加载禁能日志失败",
      "loadCashLogFailed": "加载现金清零记录失败",
      "loadDeviceTagsFailed": "加载设备标签失败",
      "loadDeviceTypesFailed": "加载设备类型失败",
      "loadFavoriteMachinesFailed": "加载收藏列表失败",
      "loadingOrgDeviceTree": "正在加载星系机器树...",
      "machines": "机器",
      "loadMachineDetailFailed": "加载机器详情失败",
      "loadOrgPayPackageFailed": "加载机构支付配置包失败",
      "loadTransferFailed": "加载转移记录失败",
      "loadTransferLogListFailed": "加载转移日志列表失败",
      "location": "位置",
      "locationInfo": "位置信息",
      "longitudeLatitude": "经纬度",
      "machineBinding": "机器绑定",
      "machineConfigExistsPrompt": "该设备已存在末端配置（machine.cfg），是否更新现有配置？",
      "machineConfigUpdateSuccess": "末端配置已更新",
      "machineImage": "机器图片",
      "machineInfo": "机器信息",
      "machineName": "机器名称",
      "machineNumber": "机器编号",
      "machineTags": "机器标签",
      "machineTransferLog": "机器转移日志",
      "machineType": "机器类型",
      "mapSelectorPending": "地图选择器功能待实现",
      "mdb": "MDB",
      "mdbProtocol": "MDB协议",
      "missingQrCodeInfo": "缺少二维码信息",
      "modeLabel": "模式：",
      "modeSwitchFailed": "模式切换失败",
      "newOrgMachineNo": "新机构机器编号",
      "next": "下一帧",
      "noBindDevice": "该机器未绑定设备",
      "noErrorMessage": "无失败原因",
      "noFavorites": "暂无收藏记录",
      "noImage": "暂无图片",
      "noPermissionAddMachine": "没有权限新增机器",
      "noPermissionAddMachineFavorite": "没有权限新增机器收藏",
      "noPermissionDeleteMachine": "没有权限删除机器",
      "noPermissionEditMachineFavorite": "没有权限编辑机器收藏",
      "noPermissionQueryMachineDetail": "没有权限查询机器详情",
      "noPermissionQueryMachineList": "没有权限查询机器列表",
      "noPermissionQueryOrgTree": "没有权限获取机构树",
      "noPermissionUpdateMachine": "没有权限编辑机器",
      "noPreviewImage": "暂无预览图片",
      "noProtocolConfig": "暂未配置协议，点击上方新增协议按钮开始配置",
      "noPulseProtocolConfig": "未找到PULSE协议配置或产品配置为空，请先配置协议",
      "noQrCodeLink": "没有可复制的链接",
      "noTransferLog": "暂无转移记录",
      "noTransferOrg": "暂无可选择的机构，请先创建机构",
      "notSet": "未设置",
      "offline": "离线",
      "oldOrgMachineNo": "旧机构机器编号",
      "online": "在线",
      "onlineStatus": "在线状态",
      "onlyImageFiles": "只能上传图片文件",
      "operateTime": "操作时间",
      "operationFailed": "操作失败，请检查表单数据",
      "operator": "操作员",
      "orgChange": "机构变更",
      "orgDeviceNumber": "机构机器号",
      "orgDeviceTree": "机构机器树",
      "orgMachineNoChange": "机构机器编号变更",
      "orgName": "机构名称",
      "orgNo": "机构号",
      "orgPaymentPackage": "机构支付包",
      "orgType": "机构类型",
      "outputSignalSentSuccess": "出货信号发送成功",
      "pause": "暂停",
      "paymentPreAnimation": "支付结果页前置动画组",
      "paymentResultAnimation": "支付结果页动画组",
      "pending": "待处理",
      "percentage": "百分比",
      "percentageRateRange": "百分比费率必须在 0-100 之间",
      "play": "播放",
      "pleaseConfigurePaymentPackage": "请先配置支付包",
      "pleaseSelectDevice": "请先选择机器",
      "pleaseSelectProduct": "请选择产品",
      "preAnimationGifs": "前置动画动图",
      "preAnimationStaticImg": "前置动画静态图",
      "preview": "预览",
      "machinePriceConfigInvalid": "机器金额配置不对，请先调整协议价格后再绑定该支付包",
      "priceOutOfPackageRange": "价格不在支付包金额范围内（最小 {min}，最大 {max}）",
      "pricePackageRangePlaceholder": "支付包范围：{min} ~ {max}",
      "previewActiveTime": "激活时间",
      "previewCashHandling": "现金处理",
      "previewChoosePlanText": "选择计划文本",
      "previewChooseProgramTitle": "选择程序标题",
      "previewCashProduct": "现金商品",
      "previewCoinCount": "硬币数量",
      "previewCoinValue": "硬币面值",
      "previewCurrencySymbol": "货币符号",
      "previewDetectionMethod": "检测方式",
      "previewDiscount": "优惠",
      "previewDiscountAmount": "折扣金额",
      "previewEnableTimeout": "启用超时",
      "previewInactiveTime": "非激活时间",
      "previewNo": "否",
      "previewPriceItem": "价格",
      "previewPriceMode": "价格模式",
      "previewPriceSettings": "价格设置",
      "previewPulse": "脉冲",
      "previewTax": "税率",
      "previewTextSettings": "文本设置",
      "previewTimeoutDuration": "超时时长",
      "previewTimeoutNonCash": "超时非现金",
      "previewTitle": "脉冲协议配置",
      "previewUnit": "个",
      "previewYes": "是",
      "previous": "上一帧",
      "priceMode": "价格模式",
      "priceModeDiscount": "折扣",
      "priceModeGift": "赠品",
      "priceNumber": "价格",
      "priceSettings": "价格设置",
      "priceText": "价格文本",
      "priceYuan": "价格",
      "prices": "个价格",
      "prodMode": "生产模式",
      "prodModeWarn": "已切换为生产模式",
      "productOptionLabel": "价格: {price} | 脉冲数: {pulseCount}",
      "productionSubtext": "已开启真实交易",
      "protocolCode": "协议编码",
      "protocolConfig": "协议配置",
      "protocolCreateSuccess": "协议创建成功",
      "protocolName": "协议名称",
      "protocolUpdateSuccess": "协议更新成功",
      "inhibit": "禁能",
      "inhibitMode": "禁能模式",
      "inhibitModeHint": "启用后，Trilad设备将按照以下逻辑被机器控制器禁能。",
      "inhibitEnabled": "开启",
      "inhibitDisabled": "关闭",
      "signalPolarity": "信号极性",
      "signalPolarityHint": "机器控制器将输出{polarity}，以禁能Trilad Payment设备。",
      "activeHigh": "高电平",
      "activeLow": "低电平",
      "pulse": "脉冲",
      "pulseActive": "脉冲激活时长",
      "pulseConfig": "脉冲配置",
      "pulseCount": "脉冲数量",
      "pulseCountMustBeMultipleOfCoinCount": "脉冲数必须是投币脉冲数（{coinCount}）的倍数",
      "pulseDevice": "脉冲设备",
      "pulseInactive": "脉冲非激活时长",
      "pulseProtocol": "脉冲协议",
      "pulseProtocolConfig": "脉冲协议配置",
      "pulsePriceRequired": "脉冲协议保存前，价格列表至少需要有一个价格大于 0",
      "mdbCurrencyNumericCodeRequired": "MDB 协议保存前，机器需要先配置支付包对应的币种数字代码",
      "pulseSettings": "脉冲设置",
      "pulseUnit": "脉冲上报单位",
      "qrCode": "二维码",
      "qrCodeDialogTitle": "二维码信息",
      "qrCodeGenerating": "正在生成二维码...",
      "qrCodeImage": "二维码",
      "qrCodeLink": "链接",
      "qrCodeNo": "二维码编号",
      "qrId": "二维码ID",
      "quantity": "数量(个)",
      "queryMachineDetailFailed": "查询机器详情失败",
      "queryMachineFavoriteListFailed": "查询机器收藏列表失败",
      "queryMachineListFailed": "查询机器列表失败",
      "queryMachineProtocolConfigFailed": "查询机器协议配置失败",
      "queryMachineTagsFailed": "获取设备标签失败",
      "queryMachineTransferLogListFailed": "查询机器转移日志列表失败",
      "queryMachineTypeFailed": "查询设备类型失败",
      "queryOrgPayPackageFailed": "获取机构支付配置包失败",
      "queryOrgTreeFailed": "获取机构树失败",
      "refreshMachineDetailFailed": "刷新机器详情失败",
      "refreshMachineDetailSuccess": "机器详情已刷新",
      "refreshOrgDeviceListFailed": "刷新机构设备列表失败",
      "remark": "备注",
      "removeFavoriteFailed": "取消收藏失败",
      "removeFavoriteSuccess": "取消收藏成功",
      "resultAnimationGifs": "结果页动画动图",
      "resultAnimationStaticImg": "结果页动画静态图",
      "resultDescription": "结果页描述",
      "resultTitle": "结果页标题",
      "sandboxMode": "测试模式",
      "sandboxModeWarn": "已切换为测试模式",
      "sandboxSubtext": "仅模拟交易",
      "save": "节省",
      "saveQrCode": "保存二维码",
      "saveQrCodeFailed": "保存失败",
      "saveQrCodeSuccess": "保存成功",
      "sceneType": "场景类型",
      "sceneTypeH5": "H5",
      "sceneTypeTerminal": "终端",
      "searchOrgOrDevice": "搜索机构或机器...",
      "searchMachines": "搜索机器...",
      "foundMachines": "找到 {count} 台机器",
      "orgScope": {
        "search": "搜索机构...",
        "select": "选择",
        "empty": "未找到机构",
        "saveFailed": "保存机构查看范围失败"
      },
      "treePopover": {
        "machineType": "机器类型",
        "machineNumber": "机器编号",
        "device": "设备",
        "notAssigned": "未绑定",
        "qr": "二维码",
        "number": "编号",
        "url": "链接",
        "checkoutPage": "收银台页面",
        "lastOnline": "最后在线"
      },
      "searching": "正在搜索包含 \"{keyword}\" 的机构或机器",
      "selectImage": "选择图片",
      "selectImageRequired": "请选择机器图片",
      "selectLocation": "选择位置",
      "selectOrgOrDevice": "请选择左侧的机器查看详情",
      "selectProduct": "选择产品",
      "selectProductPlaceholder": "请选择产品",
      "selectTargetOrg": "请选择目标机构",
      "sendOutputSignalFailed": "发送出货信号失败，请稍后重试",
      "serviceFeeRate": "服务费费率",
      "serviceFeeType": "服务费类型",
      "shenzhen": "深圳",
      "shenzhenIndustrialPark": "深圳市宝安区工业园",
      "showInsertedCoinCount": "显示投入硬币数量",
      "singlePriceGoodsNameText": "单价格下商品名称文本",
      "singlePriceGoodsUnitText": "单价格下商品单位",
      "stateLabel": "状态：",
      "supportOnlinePayment": "支持线上支付",
      "switchToSandbox": "切换到测试",
      "sysMachineNo": "系统机器编号",
      "systemDeviceNumber": "系统机器号",
      "taxRate": "税率(%)",
      "taxSettings": "税率设置",
      "protocolConfigTitle": "{protocol}配置",
      "mdbCurrencyScaling": "货币缩放",
      "mdbExample": "举例",
      "mdbScaleFactor": "缩放因子",
      "mdbDecimalPlace": "小数位",
      "mdbProtocolLevel": "MDB 协议级别",
      "mdbLevelOption": "级别 {level}",
      "mdbLevelHintEnabled": "Level 3 启用始终空闲模式。修改该参数后设备会重启",
      "mdbLevelHintConnected": "当前连接的机器使用 MDB Level 2",
      "mdbLevelHintDisabled": "MDB Level {level} 不支持始终空闲模式",
      "mdbAlwaysIdleMode": "始终空闲模式",
      "mdbAlwaysIdleHintEnabled": "交易将从在售货机上选择商品开始",
      "mdbAlwaysIdleHintDisabled": "交易将从触摸终端开始，并向售货机提供默认信用额",
      "mdbAlwaysIdleHintUnavailable": "已禁用，因为始终空闲模式仅支持 MDB Level 3 或更高版本",
      "mdbCreditLimit": "默认信用额度",
      "mdbDefaultCredit": "默认 Credit",
      "mdbUseHighestLimit": "使用最高限制",
      "mdbMonetaryFormat": "金额格式",
      "mdbMonetaryFormat16Hint": "适用于兼容机器控制器的标准金额格式。",
      "mdbMonetaryFormat32Hint": "当机器控制器支持时，可扩展金额范围以支持高金额交易。",
      "mdbCreditLimitAdjusted": "已切换为 {format}，默认信用额度已调整至最大允许值 {value}。",
      "mdbCreditLimitHint": "允许的最大值是 {value} ({maxInteger} × Scale Factor / (10^Decimal Place))",
      "mdbAutoRefund": "自动退款",
      "mdbAutoRefundHint": "当支付成功但机器上报出货失败时，自动向顾客退款",
      "mdbVendResultTimeout": "出货结果超时",
      "mdbVendResultTimeoutHint": "最大 1800 秒",
      "mdbCashSale": "现金销售",
      "mdbCashSaleHint": "允许 VMC 向 Trilad 设备上报现金交易",
      "mdbSessionIdleTimeout": "会话空闲超时",
      "mdbMaximum255Seconds": "最大 255 秒",
      "mdbApplicationMaximumResponseTime": "应用最大响应时间",
      "textSettings": "文本设置",
      "theme": "主题",
      "themeZorbamaticGemstone": "Zorbamatic Gemstone",
      "themeZorbamaticWoodenBalls": "Zorbamatic Wooden Balls",
      "themeDarkFlame": "深色火焰",
      "themeDefault": "默认主题",
      "themePeppaPigKiddleRide": "小猪佩奇儿童骑乘",
      "themeGashapon": "扭蛋机",
      "themeArcade": "街机",
      "themePennyPress": "纪念币压制机",
      "themePinball": "弹球机",
      "themeMassageChair": "按摩椅",
      "timeoutDuration": "超时时长",
      "timeoutNonCash": "出货超时后允许非现金交易",
      "timeoutSettings": "超时设置",
      "title": "机器管理",
      "toOrg": "目标机构",
      "totalAmount": "总金额",
      "totalFrames": "总图数",
      "transferFailed": "机器转移失败",
      "transferMode": "转移方式",
      "transferModeOrgNo": "输入机构号",
      "transferModeTree": "机构树选择",
      "transferOrgSameWarning": "目标机构不能与当前机构相同",
      "transferReason": "转移原因",
      "transferResult": "转移结果",
      "transferStatus": "转移状态",
      "transferSuccess": "机器转移成功",
      "triladSerial": "Trilad串口",
      "triladSerialProtocol": "Trilad串口协议",
      "unbindDevice": "解绑",
      "unbindDeviceFailed": "解绑设备失败",
      "unbindDeviceSuccess": "解绑设备成功",
      "unbound": "未绑定",
      "unitSecond": "秒(s)",
      "unknownDevice": "未知设备",
      "unsupportedPlatProductCode": "不支持的平台产品代码",
      "updateMachineFailed": "编辑机器失败",
      "updateMachineSuccess": "编辑机器成功",
      "uploadGif": "上传GIF动图",
      "uploadGifTip": "支持GIF格式，单张图片不超过1MB",
      "uploadImage": "上传图片",
      "uploadImageTip": "支持JPG、PNG、GIF格式，单张图片不超过1MB",
      "viewAccessLog": "查看日志",
      "viewQrCode": "查看二维码",
      "viewTransactions": "查看交易"
    }
  },
  "report": {
    "authorizationOrder": {
      "dialog": {
        "authInfo": "授权信息",
        "basicInfo": "基本信息",
        "captureAmount": "捕获金额",
        "captureInfo": "捕获订单",
        "captureOrderNo": "捕获订单号",
        "captureStatus": "捕获状态",
        "captureTime": "捕获时间",
        "channelErrorCode": "渠道错误码",
        "channelErrorMsg": "渠道错误信息",
        "channelResponseTime": "渠道响应时间",
        "goodsAmount": "商品金额",
        "machineName": "机器名称",
        "machineNumber": "机器编号",
        "noCaptureOrder": "暂无捕获订单",
        "noVoidOrder": "暂无取消订单",
        "orgPayFee": "机构手续费",
        "outputNums": "出货数量",
        "outputStatus": "出货状态",
        "payResponseTime": "支付返回时间",
        "payToken": "支付Token",
        "remark": "备注",
        "serviceFee": "服务费",
        "settleTime": "结算时间",
        "taxFee": "税费",
        "thirdDes": "第三方描述",
        "thirdResponseTime": "三方返回时间",
        "title": "授权订单详情",
        "traceId": "API请求单号",
        "voidAmount": "取消金额",
        "voidInfo": "取消订单",
        "voidOrderNo": "取消订单号",
        "voidStatus": "取消状态",
        "voidTime": "取消时间"
      },
      "messages": {
        "loadCaptureFailed": "加载捕获订单失败",
        "loadDataFailed": "加载授权订单数据失败",
        "loadDetailFailed": "加载授权订单详情失败",
        "loadVoidFailed": "加载取消订单失败"
      },
      "searchForm": {
        "channelAuthOrderNo": "通道授权订单号",
        "dateRange": "日期范围",
        "deviceNumbers": "Device编号",
        "endPlaceholder": "结束日期",
        "keyword": "关键词搜索",
        "machineNumbers": "Machine编号",
        "merchantAuthOrderNo": "商户授权订单号",
        "orderStatus": "订单状态",
        "placeholder": {
          "deviceNumbers": "请选择Device编号",
          "keyword": "请输入订单号、设备号等关键词",
          "machineNumbers": "请选择Machine编号"
        },
        "platformAuthOrderNo": "平台授权订单号",
        "rangeSeparator": "至",
        "startPlaceholder": "开始日期"
      },
      "status": {
        "FAILED": "失败",
        "Processing": "处理中",
        "SUCCEEDED": "成功",
        "UNATTEMPTED": "未执行",
        "closed": "已关门",
        "opened": "已开门",
        "pending": "待处理",
        "processing": "处理中",
        "shipped": "已发货",
        "shippedFail": "发货失败",
        "unShipped": "未发货"
      },
      "table": {
        "authAmount": "授权金额",
        "authStatus": "授权状态",
        "captureAmount": "捕获金额",
        "captureStatus": "捕获状态",
        "channelAuthOrderNo": "通道授权订单号",
        "createTime": "创建时间",
        "currency": "币种",
        "deviceId": "设备ID",
        "deviceName": "设备名称",
        "deviceSn": "设备号",
        "doorStatus": "开关门状态",
        "merchantAuthOrderNo": "商户授权订单号",
        "operation": "操作",
        "orgMachineNo": "机构机器号",
        "payChannel": "支付渠道",
        "payMethod": "支付方式",
        "platformAuthOrderNo": "平台授权订单号",
        "thirdStatus": "第三方状态",
        "updateTime": "更新时间",
        "viewDetail": "查看详情",
        "voidStatus": "撤销状态"
      },
      "thirdStatus": {
        "00": "成功",
        "01": "失败"
      },
      "title": "预授权订单"
    },
    "transactions": {
      "title": "交易列表",
      "export": "导出",
      "exportProgress": {
        "title": "导出",
        "exporting": "正在导出...",
        "count": "已获取 {fetched} / {total}"
      },
      "exportHeaders": {
        "txnId": "交易 ID",
        "machineName": "机器名称",
        "machineNumber": "机器编号",
        "deviceType": "设备类型",
        "deviceNo": "设备号",
        "type": "类型",
        "status": "状态",
        "selectionProducts": "商品",
        "currency": "币种",
        "orderAmount": "订单金额",
        "authAmount": "授权金额",
        "settledAmount": "结算金额",
        "createdTime": "创建时间",
        "settlementTime": "结算时间",
        "authTime": "授权时间",
        "paymentChannel": "支付方式",
        "paymentProvider": "支付通道",
        "paymentMethod": "支付方式",
        "galaxyName": "机构名称",
        "galaxyId": "机构 ID"
      },
      "liveMode": "正式环境",
      "demoMode": "演示环境",
      "search": {
        "dateRange": "日期范围",
        "createdTime": "创建时间",
        "authTime": "授权时间",
        "settlementTime": "结算时间",
        "to": "至",
        "startTime": "开始时间",
        "endTime": "结束时间",
        "txnId": "交易 ID",
        "txnIdPlaceholder": "请输入交易 ID",
        "machineDevice": "机器/设备",
        "machineDevicePlaceholder": "请输入名称/编号/SN/QR",
        "galaxy": "机构",
        "galaxyPlaceholder": "请选择机构",
        "type": "交易类型",
        "status": "状态",
        "payment": "支付",
        "method": "Method",
        "channel": "Channel",
        "provider": "Provider"
      },
      "table": {
        "displayOrderNo": "交易 ID",
        "machineDevice": "机器/设备",
        "galaxyId": "机构/ID",
        "machineNo": "机器编号",
        "deviceSn": "设备 SN",
        "methodChannel": "方式/渠道",
        "typeStatus": "类型/状态",
        "selectionProducts": "商品",
        "orderAmount": "订单金额",
        "authAmount": "授权金额",
        "settledAmount": "结算金额",
        "authTime": "授权时间",
        "settlementTime": "结算时间",
        "paymentChannel": "支付方式",
        "paymentProvider": "支付通道",
        "paymentMethod": "支付方式",
        "createdTime": "创建时间",
        "operation": "操作",
        "clickToCopy": "点击复制",
        "machineConfiguration": "机器配置"
      },
      "type": {
        "sale": "消费",
        "freeVend": "免费出货",
        "preAuth": "预授权",
        "cash": "现金",
        "refund": "退款"
      },
      "status": {
        "pending": "待处理",
        "processing": "处理中",
        "refundProcessing": "退款处理中",
        "success": "成功",
        "failed": "失败",
        "refundFailed": "退款失败",
        "authFailed": "授权失败",
        "cancelled": "已取消",
        "authorized": "已授权",
        "notComplete": "未完成",
        "voided": "已撤销",
        "refundReview": "退款审核中",
        "refundRejected": "退款已拒绝",
        "fullyRefunded": "全额退款",
        "partiallyRefunded": "部分退款"
      },
      "detail": {
        "currentTimezone": "当前时区",
        "machineTimezone": "机器时区",
        "tabs": {
          "payment": "支付",
          "refund": "退款",
          "order": "订单",
          "fees": "费用",
          "machine": "机器"
        },
        "machineInfo": "机器信息",
        "type": "类型",
        "currency": "币种",
        "status": "状态",
        "fee": "手续费",
        "netAmount": "净额",
        "authorized": "已授权",
        "order": "订单",
        "settled": "已结算",
        "vend": "出货",
        "vendStatus": {
          "success": "成功",
          "processing": "处理中",
          "failed": "失败"
        },
        "machineName": "机器名称",
        "machineNo": "机器编号",
        "systemMachineNo": "系统机器编号",
        "deviceNo": "设备号",
        "qrNo": "二维码编号",
        "location": "位置",
        "operatorName": "运营方名称",
        "operatorId": "运营方编号",
        "paymentMethod": "支付方式",
        "paymentChannel": "支付方式",
        "paymentProvider": "支付通道",
        "providerTxnId": "支付通道交易号",
        "payerName": "付款人姓名",
        "createdTime": "创建时间",
        "authTime": "授权时间",
        "settlementTime": "结算时间",
        "refundOrder": "退款订单",
        "refundApplications": "退款申请",
        "id": "ID",
        "refundTime": "退款时间",
        "applicant": "申请人",
        "applicationTime": "申请时间",
        "auditComment": "审核意见",
        "description": "描述",
        "units": "数量",
        "price": "单价",
        "amount": "金额",
        "bill": "纸币",
        "coin": "硬币",
        "totalAmount": "总金额",
        "subtotal": "小计",
        "discount": "折扣",
        "tax": "税费",
        "convenienceFee": "便利费",
        "handlingFee": "手续费",
        "transactionTax": "手续费增值税"
      },
      "messages": {
        "loadDataFailed": "加载交易列表失败",
        "noExportData": "没有数据可以导出"
      }
    },
    "refundApply": {
      "auditDialog": {
        "auditComment": "审核意见",
        "auditResult": "审核结果",
        "confirmMessage": "确定要{result}该退款申请吗？",
        "confirmTitle": "确认审核",
        "placeholder": {
          "auditComment": "请输入审核意见（拒绝时必填）"
        },
        "title": "审核退款申请",
        "validation": {
          "auditCommentLength": "审核意见长度不能超过500个字符",
          "auditCommentRequiredForReject": "拒绝时必须填写审核意见",
          "auditResultRequired": "请选择审核结果"
        }
      },
      "auditResult": {
        "APPROVED": "通过",
        "REJECTED": "拒绝"
      },
      "dateRange": {
        "endPlaceholder": "结束日期",
        "separator": "至",
        "startPlaceholder": "开始日期"
      },
      "dialog": {
        "applyInfo": "申请信息",
        "title": "申请详情"
      },
      "messages": {
        "auditFailed": "审核失败",
        "auditSuccess": "审核成功",
        "loadDataFailed": "加载退款申请数据失败",
        "loadDetailFailed": "加载申请详情失败"
      },
      "searchForm": {
        "applyNo": "申请单号",
        "applyStatus": "申请状态",
        "dateRange": "申请时间",
        "orderNo": "订单号"
      },
      "status": {
        "APPROVED": "已通过",
        "CANCELLED": "已取消",
        "PENDING": "待审核",
        "REJECTED": "已拒绝",
        "REFUND_PROCESSING": "退款处理中",
        "REFUND_SUCCEEDED": "退款成功",
        "REFUND_FAILED": "退款失败"
      },
      "table": {
        "applicantName": "申请人",
        "applyAmount": "申请金额",
        "applyNo": "申请单号",
        "applyReason": "申请原因",
        "applyStatus": "申请状态",
        "applyTime": "申请时间",
        "audit": "审核",
        "auditComment": "审核意见",
        "auditTime": "审核时间",
        "auditorName": "审核人",
        "currency": "币种",
        "operation": "操作",
        "orderNo": "订单号",
        "refundOrderNo": "退款订单号",
        "viewDetail": "查看详情"
      },
      "title": "退款申请管理"
    },
    "salesAnalysis": {
      "salesDescription": "销售分析功能正在开发中，敬请期待...",
      "salesDeveloping": "功能开发中",
      "title": "销售分析"
    },
    "salesByMachine": {
      "title": "按机器销售",
      "exportProgress": {
        "title": "导出 Excel",
        "exporting": "正在导出...",
        "count": "已获取 {fetched} / {total}"
      },
      "exportHeaders": {
        "machineName": "机器名称",
        "machineNumber": "机器编号",
        "deviceType": "设备类型",
        "deviceNo": "设备号",
        "galaxyName": "机构名称",
        "galaxyCurrency": "机构币种",
        "totalsTxns": "总计笔数",
        "totalsGrossAmt": "总计总金额",
        "totalsCashlessCashPct": "总计无现金/现金 $%",
        "cashlessTxns": "无现金笔数",
        "cashlessGrossAmt": "无现金总金额",
        "cashlessAtv": "无现金 ATV",
        "cashTxns": "现金笔数",
        "cashAmount": "现金金额",
        "cashAtv": "现金 ATV",
        "refundTxns": "退款笔数",
        "refundAmt": "退款金额"
      },
      "overview": {
        "totalMachines": "机器总数",
        "transactingMachines": "交易机器数"
      },
      "search": {
        "galaxy": "Galaxy",
        "galaxyPlaceholder": "请选择机构",
        "dateRange": "日期范围",
        "to": "至",
        "startTime": "开始时间",
        "endTime": "结束时间",
        "reportingCurrency": "报表币种",
        "payment": "无现金支付",
        "machineDevice": "机器 / 设备",
        "machineDevicePlaceholder": "请输入名称/编号/SN/QR"
      },
      "table": {
        "index": "序号",
        "machineDevice": "机器 / 设备",
        "galaxyCurrency": "机构 / 币种",
        "currency": "币种",
        "totals": "总计",
        "cashless": "无现金",
        "cash": "现金",
        "txns": "笔数",
        "grossAmt": "总金额",
        "cashlessCashPct": "无现金 / 现金 $%",
        "atv": "ATV",
        "amount": "金额",
        "refundTxns": "退款笔数",
        "refundAmt": "退款金额",
        "netAmount": "净额",
        "operation": "操作"
      },
      "summary": {
        "totalAllResults": "总计 - 全部结果"
      },
      "messages": {
        "noExportData": "没有数据可以导出"
      },
      "columnPreference": {
        "title": "添加/移除字段",
        "description": "选择要显示的列。"
      }
    },
    "transactionOrder": {
      "cashBreakdown": {
        "bill": "纸币",
        "coin": "硬币"
      },
      "dateRange": {
        "endPlaceholder": "结束日期",
        "separator": "至",
        "startPlaceholder": "开始日期"
      },
      "dialog": {
        "amountInfo": "金额信息",
        "applicantName": "申请人",
        "applyAmount": "申请金额",
        "applyNo": "申请单号",
        "applyStatus": "申请状态",
        "applyTime": "申请时间",
        "auditComment": "审核意见",
        "basicInfo": "基本信息",
        "channelRefundOrderNo": "渠道退款订单号",
        "commissionServiceFee": "佣金服务费",
        "currency": "币种",
        "discountAmount": "商品折扣费",
        "goodsAmount": "商品金额",
        "mdrVatAmount": "交易税费",
        "merchantReceivedAmount": "商户到账金额",
        "merchantRefundOrderNo": "商户退款订单号",
        "noRefundApplies": "暂无退款申请",
        "noRefundOrders": "暂无退款订单",
        "orgPayFee": "手续费",
        "productExternalId": "商品外部ID",
        "productInfo": "商品信息",
        "productInfoLabel": "商品信息",
        "productInternalCode": "商品内部编号",
        "profit": "平台利润",
        "refundAmount": "退款金额",
        "refundAmountLabel": "退款金额",
        "refundApplies": "退款申请记录",
        "refundOrderNo": "退款订单号",
        "refundOrders": "退款订单",
        "refundStatus": "退款状态",
        "refundTime": "退款时间",
        "serviceFee": "服务费",
        "singleProductCode": "单品编号",
        "title": "订单详情"
      },
      "envMode": {
        "production": "生产环境",
        "sandbox": "沙箱环境"
      },
      "messages": {
        "loadDataFailed": "加载订单数据失败",
        "loadDetailFailed": "加载订单详情失败",
        "loadRefundApplyFailed": "加载退款申请记录失败",
        "refundAuditNoLongerPending": "当前退款申请不存在或已处理",
        "loadRefundFailed": "加载退款订单失败",
        "refundApplyFailed": "提交退款申请失败",
        "refundApplyPending": "该订单存在待审核的退款申请，无法发起新的申请",
        "refundApplySuccess": "退款申请已提交，等待审核",
        "refundFailed": "退款失败",
        "refundPending": "该订单存在处理中的退款，无法发起新的退款",
        "refundSuccess": "退款成功"
      },
      "orderType": {
        "capture": "预授权完成",
        "cash_order": "现金",
        "feeVend": "免费出货",
        "qr": "动态二维码",
        "transfer": "销售",
        "void_order": "预授权取消"
      },
      "prizeWin": {
        "0": "没有",
        "1": "出货"
      },
      "pulseStatus": {
        "0": "等待补全",
        "1": "消耗中",
        "2": "消耗完成"
      },
      "recognitionMethod": {
        "H5": "H5",
        "chip": "芯片卡",
        "magnetic": "磁条卡"
      },
      "auditDialog": {
        "amountRequested": "申请退款金额",
        "auditAction": "审核退款申请",
        "approveMessage": "确定要通过这笔交易的退款申请吗？",
        "approveTitle": "通过退款",
        "by": "By",
        "comment": "备注",
        "placeholder": {
          "approveComment": "请输入附加备注。（选填）",
          "rejectReason": "请输入拒绝原因。"
        },
        "refundReason": "退款原因",
        "rejectMessage": "确定要拒绝该退款申请吗？",
        "rejectReason": "原因",
        "rejectTitle": "拒绝退款",
        "requestTime": "申请时间",
        "requestTitle": "退款申请",
        "requestedBy": "申请人",
        "validation": {
          "commentLength": "内容长度不能超过255个字符",
          "rejectReasonRequired": "请输入拒绝原因"
        }
      },
      "refundDialog": {
        "applyConfirmMessage": "确定要提交退款申请 {amount} 元吗？",
        "applyConfirmTitle": "确认提交申请",
        "applyTitle": "退款申请",
        "confirmMessage": "确定要退款 {amount} 元吗？",
        "confirmTitle": "确认退款",
        "orderNo": "订单号",
        "placeholder": {
          "refundAmount": "请输入退款金额",
          "refundReason": "请输入退款说明",
          "withdrawMethodKey": "请输入用户密钥"
        },
        "refundAmount": "退款金额",
        "refundReason": "退款说明",
        "refundableAmount": "最大可退金额",
        "refundedAmount": "已退款金额",
        "requestAction": "申请",
        "title": "退款",
        "totalAmount": "订单总金额",
        "validation": {
          "refundAmountMax": "退款金额不能超过{max}",
          "refundAmountMin": "退款金额必须大于0",
          "refundAmountRequired": "请输入退款金额",
          "refundReasonLength": "退款说明长度应在1到500个字符之间",
          "refundReasonRequired": "请输入退款说明",
          "withdrawMethodKeyLength": "用户密钥长度不能超过200个字符",
          "withdrawMethodKeyRequired": "请输入用户密钥"
        },
        "withdrawMethodKey": "用户密钥"
      },
      "searchForm": {
        "channelOrderNo": "渠道订单号",
        "dateRange": "日期范围",
        "deviceNumbers": "Device编号",
        "keyword": "关键词搜索",
        "machineNo": "机器编号",
        "machineNumbers": "Machine编号",
        "merchantOrderNo": "商户订单号",
        "orderNo": "订单号",
        "orderStatus": "交易状态",
        "orderType": "订单类型",
        "placeholder": {
          "deviceNumbers": "请选择Device编号",
          "keyword": "请输入订单号、设备号等关键词",
          "machineNo": "请输入机器编号",
          "machineNumbers": "请选择Machine编号",
          "orderNo": "请输入订单号"
        },
        "platformOrderNo": "平台订单号"
      },
      "status": {
        "FAILED": "失败",
        "Processing": "处理中",
        "SUCCEEDED": "成功",
        "UNATTEMPTED": "未执行",
        "processing": "处理中",
        "shipped": "已发货",
        "shippedFail": "发货失败",
        "unShipped": "未发货"
      },
      "table": {
        "authDate": "授权日期",
        "authTime": "授权时间",
        "billAmount": "纸币金额",
        "channelOrderNo": "渠道订单号",
        "coinAmount": "硬币金额",
        "currency": "货币",
        "deviceId": "设备ID",
        "deviceName": "设备名称",
        "deviceSn": "设备SN",
        "envMode": "环境模式",
        "machineName": "机构机器名称",
        "machineNumber": "机构机器编号",
        "merchantOrderNo": "商户订单号",
        "netAmount": "净金额",
        "operation": "操作",
        "orderStatus": "交易状态",
        "orderType": "交易类型",
        "orgMachineNo": "机构机器号",
        "outputStatus": "出货状态",
        "payChannel": "支付渠道",
        "payMethod": "支付方式",
        "platformOrderNo": "平台订单号",
        "prizeWin": "中奖情况",
        "productCode": "商品编码",
        "productName": "商品名称",
        "recognitionMethod": "识别方式",
        "refund": "退款",
        "refundAmount": "退款金额",
        "refundApply": "退款",
        "refundStatus": "退款状态",
        "remark": "备注",
        "serviceFee": "服务费",
        "settleDate": "结算日期",
        "settleTime": "结算时间",
        "taxAmount": "税额",
        "totalAmount": "总金额",
        "viewDetail": "查看详情"
      },
      "title": "交易订单"
    }
  },
  "routeButton": {
    "auth_getRoleAuth": "获取角色权限",
    "button_add": "新增按钮",
    "button_delete": "删除按钮",
    "button_findAll": "查询所有按钮",
    "button_getMenuButton": "查询菜单按钮",
    "button_update": "编辑按钮",
    "channelPlatProduct_add": "新增关联支付通道",
    "channelPlatProduct_delete": "删除关联支付通道",
    "channelPlatProduct_getPage": "查询关联支付通道",
    "channelProduct_add": "新增渠道产品",
    "channelProduct_delete": "删除渠道产品",
    "channelProduct_getPage": "查询渠道产品列表",
    "channelProduct_update": "编辑渠道产品",
    "country_add": "新增国家",
    "country_delete": "删除国家",
    "country_getPage": "查询国家列表",
    "country_update": "编辑国家",
    "currency_add": "新增货币",
    "currency_delete": "删除货币",
    "currency_getPage": "查询货币列表",
    "currency_update": "编辑货币",
    "dashboard_getCurrencyOptions": "获取货币选项",
    "dashboard_getMachineLocationList": "获取机器位置列表",
    "dashboard_getMachineOptions": "获取机器选项",
    "dashboard_getMachinePerformanceBottom": "获取机器性能底部数据",
    "dashboard_getMachinePerformanceTop": "获取机器性能顶部数据",
    "dashboard_getMachineStatusSummary": "获取机器状态汇总",
    "dashboard_getMultiPeriodOverview": "获取多周期概览",
    "dashboard_getPayMethodOptions": "获取支付方式选项",
    "dashboard_getPaymentMethodBreakdown": "获取支付方式明细",
    "dashboard_getSalesTrend": "获取销售趋势",
    "deviceCommandLog_add": "新增设备命令日志",
    "deviceCommandLog_delete": "删除设备命令日志",
    "deviceCommandLog_getPage": "查询设备命令日志列表",
    "deviceCommandLog_update": "编辑设备命令日志",
    "deviceConfigTemplate_add": "新增设备配置模板",
    "deviceConfigTemplate_delete": "删除设备配置模板",
    "deviceConfigTemplate_getPage": "查询设备配置模板",
    "deviceConfigTemplate_update": "修改设备配置模板",
    "deviceConfig_add": "新增设备配置",
    "deviceConfig_delete": "删除设备配置",
    "deviceConfig_getConfig": "查询设备配置",
    "deviceConfig_getPage": "查询设备配置列表",
    "deviceConfig_pushConfig": "推送设备配置",
    "deviceConfig_sendCommand": "发送设备命令",
    "deviceConfig_update": "编辑设备配置",
    "deviceModelConfig_add": "新增设备模块配置",
    "deviceModelConfig_delete": "删除设备模块配置",
    "deviceModelConfig_getPage": "查询设备模块配置",
    "deviceModelConfig_update": "修改设备模块配置",
    "deviceType_add": "新增设备类型",
    "deviceType_delete": "删除设备类型",
    "deviceType_getPage": "查询设备类型列表",
    "deviceType_update": "编辑设备类型",
    "device_add": "新增设备",
    "device_advanced_settings": "设备高级设置",
    "device_batchRegister": "设备批量注册",
    "device_delete": "删除设备",
    "device_getDetail": "查询设备详情",
    "device_getDeviceInfo": "查询设备信息",
    "device_getPage": "查询设备列表",
    "device_getStatus": "查询设备状态",
    "device_update": "编辑设备",
    "device_bindMachine": "绑定机器",
    "dictItem_add": "新增字典项",
    "dictItem_delete": "删除字典项",
    "dictItem_getPage": "查询字典项列表",
    "dictItem_update": "编辑字典项",
    "dict_add": "新增字典",
    "dict_delete": "删除字典",
    "dict_getPage": "查询字典列表",
    "dict_update": "编辑字典",
    "file_upload": "文件上传",
    "machineCashClearLog_getList": "查询现金清零记录",
    "machineDeviceRel_getPage": "查询机器设备关联列表",
    "machineFavorite_add": "新增机器收藏",
    "machineFavorite_delete": "删除机器收藏",
    "machineFavorite_getPage": "查询机器收藏列表",
    "machineFavorite_update": "编辑机器收藏",
    "machineProtocolConfig_add": "新增机器协议配置",
    "machineProtocolConfig_delete": "删除机器协议配置",
    "machineProtocolConfig_getByMachineId": "根据机器ID查询机器协议配置列表",
    "machineProtocolConfig_getPage": "查询机器协议配置列表",
    "machineProtocolConfig_update": "编辑机器协议配置",
    "machineTagRel_add": "新增机器标签关系",
    "machineTagRel_delete": "删除机器标签关系",
    "machineTagRel_getPage": "查询机器标签关系列表",
    "machineTagRel_update": "编辑机器标签关系",
    "machineTag_add": "新增机器标签",
    "machineTag_delete": "删除机器标签",
    "machineTag_find": "查询机器标签",
    "machineTag_getPage": "查询机器标签列表",
    "machineTag_update": "编辑机器标签",
    "machineTransferLog_add": "新增机器转移日志",
    "machineTransferLog_delete": "删除机器转移日志",
    "machineTransferLog_getPage": "查询机器转移日志列表",
    "machineTransferLog_update": "编辑机器转移日志",
    "machineType_add": "新增机器类型",
    "machineType_delete": "删除机器类型",
    "machineType_find": "查询机器类型",
    "machineType_getPage": "查询机器类型列表",
    "machineType_update": "编辑机器类型",
    "machine_add": "新增机器",
    "machine_bind": "机器绑定",
    "machine_clearCash": "清零现金",
    "machine_delete": "删除机器",
    "machine_getDetail": "查询机器详情",
    "machine_getPage": "查询机器列表",
    "machine_manualOutput": "手动出货",
    "machine_switchEnvMode": "切换环境模式",
    "machine_transfer": "机器转移",
    "machine_unbindDevice": "解绑设备",
    "machine_update": "编辑机器",
    "mainOrder_queryList": "查询预授权订单列表",
    "mediaResource_add": "新增媒体资源",
    "mediaResource_delete": "删除媒体资源",
    "mediaResource_getPage": "查询媒体资源列表",
    "mediaResource_update": "编辑媒体资源",
    "menuAuth_addAuthBatch": "批量添加菜单权限",
    "menuAuth_getAllMenu": "查询所有菜单",
    "menuAuth_getMenuButton": "查询菜单按钮",
    "menu_add": "新增菜单",
    "menu_delete": "删除菜单",
    "menu_findAll": "查询所有菜单",
    "menu_update": "编辑菜单",
    "openApiGameWayConfig_add": "新增OpenAPI网关配置",
    "openApiGameWayConfig_delete": "删除OpenAPI网关配置",
    "openApiGameWayConfig_getByOrgId": "根据机构ID查询OpenAPI网关配置",
    "openApiGameWayConfig_getByOrgIdAndGatewayType": "根据机构ID和网关类型查询OpenAPI网关配置",
    "openApiGameWayConfig_getPage": "查询OpenAPI网关配置列表",
    "openApiGameWayConfig_update": "编辑OpenAPI网关配置",
    "openApiKey_add": "新增OpenAPI Key",
    "openApiKey_delete": "删除OpenAPI Key",
    "openApiKey_getDetail": "查询OpenAPI Key详情",
    "openApiKey_getPage": "查询OpenAPI Key列表",
    "openApiKey_resetPassword": "重置OpenAPI Key密码",
    "openApiKey_update": "编辑OpenAPI Key",
    "oper_addOper": "新增操作员",
    "oper_del": "删除操作员",
    "oper_findPageOper": "查询操作员列表",
    "oper_findPageSubOper": "查询下级操作员列表",
    "oper_resetPassWord": "重置密码",
    "oper_update": "编辑操作员",
    "order_queryList": "查询订单列表",
    "orgPayChannel_add": "新增机构支付渠道",
    "orgPayChannel_delete": "删除机构支付渠道",
    "orgPayChannel_getPage": "查询机构支付渠道列表",
    "orgPayChannel_update": "编辑机构支付渠道",
    "orgPayMethod_add": "新增机构支付方式",
    "orgPayMethod_delete": "删除机构支付方式",
    "orgPayMethod_getPage": "查询机构支付方式列表",
    "orgPayMethod_update": "编辑机构支付方式",
    "orgPayPackageChannel_add": "新增机构支付套餐渠道",
    "orgPayPackageChannel_delete": "删除机构支付套餐渠道",
    "orgPayPackageChannel_getPage": "查询机构支付配置包渠道列表",
    "orgPayPackageChannel_update": "编辑机构支付套餐渠道",
    "orgPayPackageMethod_add": "新增机构支付套餐方式",
    "orgPayPackageMethod_delete": "删除机构支付套餐方式",
    "orgPayPackageMethod_getPage": "查询机构支付配置包方法列表",
    "orgPayPackageMethod_getPayMethodsByChannel": "按渠道查询机构包支付方式",
    "orgPayPackageMethod_update": "编辑机构支付套餐方式",
    "orgPayPackage_add": "新增机构支付套餐",
    "orgPayPackage_delete": "删除机构支付套餐",
    "orgPayPackage_getPage": "查询机构支付套餐列表",
    "orgPayPackage_update": "编辑机构支付套餐",
    "org_delete": "删除机构",
    "org_getDeviceCountByOrg": "查询机构设备数量",
    "org_getOrgDetail": "查询机构详情",
    "org_getTreeList": "查询机构树列表",
    "org_initNewOrg": "初始化新机构",
    "org_update": "编辑机构",
    "payChannel_add": "新增支付通道",
    "payChannel_delete": "删除支付通道",
    "payChannel_getDetailPage": "查询支付通道详细信息列表",
    "payChannel_getPage": "查询支付通道列表",
    "payChannel_update": "编辑支付通道",
    "payMethodChannelProduct_add": "新增支付方式渠道产品",
    "payMethodChannelProduct_delete": "删除支付方式渠道产品",
    "payMethodChannelProduct_getPage": "查询支付方式渠道产品列表",
    "payMethodChannelProduct_getPayMethodWithProductsPage": "查询支付方式及其关联的渠道产品列表",
    "payMethodChannelProduct_update": "编辑支付方式渠道产品",
    "payMethod_add": "新增支付方式",
    "payMethod_delete": "删除支付方式",
    "payMethod_getPage": "查询支付方式列表",
    "payMethod_update": "编辑支付方式",
    "permissionGroupRel_add": "新增权限组关系",
    "permissionGroupRel_delete": "删除权限组关系",
    "permissionGroupRel_getMenuButton": "查询权限组菜单按钮",
    "permissionGroupRel_getPage": "查询权限组关系列表",
    "permissionGroupRel_sync": "同步权限组关系",
    "permissionGroupRel_update": "编辑权限组关系",
    "permissionGroup_add": "新增权限组",
    "permissionGroup_delete": "删除权限组",
    "permissionGroup_getPage": "查询权限组列表",
    "permissionGroup_update": "编辑权限组",
    "platProduct_add": "新增平台产品",
    "platProduct_delete": "删除平台产品",
    "platProduct_getPage": "查询平台产品",
    "platProduct_update": "修改平台产品",
    "qrCode_add": "新增二维码",
    "qrCode_generate": "生成二维码",
    "qrCode_getPage": "查询二维码列表",
    "qrCode_unbindById": "解除二维码绑定",
    "qrCode_update": "编辑二维码",
    "refundApply_audit": "审核退款申请",
    "refundApply_detail": "查看退款申请详情",
    "refundApply_queryList": "查询退款申请列表",
    "refundApply_submit": "提交退款申请",
    "refundOrder_create": "创建退款订单",
    "refundOrder_queryList": "查询退款订单列表",
    "rolePermissionGroupRel_add": "新增角色权限组关系",
    "rolePermissionGroupRel_delete": "删除角色权限组关系",
    "rolePermissionGroupRel_getPage": "查询角色权限组关系列表",
    "rolePermissionGroupRel_update": "编辑角色权限组关系",
    "role_add": "新增角色",
    "role_delete": "删除角色",
    "role_get": "查询角色",
    "role_getAllRole": "查询所有角色",
    "role_roleDetail": "查询角色详情",
    "role_update": "编辑角色",
    "sysParams_add": "新增系统参数",
    "sysParams_findByParamName": "根据参数名查询",
    "sysParams_getAllList": "查询所有系统参数",
    "sysParams_update": "编辑系统参数",
    "test(空按钮 勿删)": "测试按钮",
    "voidOrder_queryList": "查询撤销订单列表",
    "app_upload": "上传ota文件",
    "app_deleteFile": "删除ota文件",
    "app_files": "查询ota文件列表",
    "app_update_app": "设备更新ota文件",
    "app_getLogPage": "查询设备更新日志列表"
  },
  "router": {
    "agencyManagement": "机构管理",
    "authorization-order": "预授权订单",
    "businessIntelligence": "BI看板",
    "countryManagement": "国家管理",
    "currencyManagement": "货币管理",
    "dashboard": "仪表盘",
    "development": "开发中心",
    "deviceConfigTemplate": "设备配置模板",
    "deviceManagement": "设备管理",
    "deviceModelConfig": "设备模块配置",
    "deviceTagManagement": "机器标签管理",
    "deviceTransferLog": "设备流转记录",
    "deviceTypeManagement": "设备类型管理",
    "dictionaryManagement": "字典管理",
    "login": "登录",
    "machine-transfer-log": "机器流转记录",
    "machineManagement": "机器管理",
    "machineTypeManagement": "机器类型管理",
    "mediaResourceManagement": "媒体资源管理",
    "menuManagement": "菜单管理",
    "myAccount": "我的账户",
    "operation": "运营管理",
    "operation-log-management": "操作日志管理",
    "operationLogManagement": "操作日志管理",
    "otaManagement": "OTA管理",
    "paymentMethodManagement": "支付方式管理",
    "paymentProviderManagement": "支付提供商管理",
    "permissionGroupManagement": "权限组管理",
    "platProductManagement": "平台业务产品",
    "platform": "平台",
    "qrCodeTransferLog": "二维码流转记录",
    "qrcodeStickerManagement": "二维码贴纸管理",
    "refund-apply-management": "退款申请管理",
    "report": "报表管理",
    "roleManagement": "角色管理",
    "salesAnalysis": "销售分析",
    "sales-by-machine": "按机器销售",
    "salesByMachine": "按机器销售",
    "setting": "设置",
    "system": "系统管理",
    "systemCenter": "系统中心",
    "systemParameterManagement": "系统参数管理",
    "systemUserManagement": "系统用户管理",
    "transaction-order": "交易订单",
    "transactionReport": "交易报表",
    "transactions": "交易列表",
    "userManagement": "用户管理"
  },
  "setting": {
    "breadcrumb": "面包屑",
    "breadcrumbIcon": "面包屑图标",
    "clearAndReset": "清除缓存并且重置",
    "copy": "拷贝",
    "copyFailed": "拷贝失败",
    "copySuccess": "拷贝成功",
    "dynamicRouter": "动态路由",
    "fixedHeader": "固定头部",
    "fixedMenu": "固定菜单",
    "footer": "页脚",
    "greyMode": "灰色模式",
    "hamburgerIcon": "折叠图标",
    "headerTheme": "头部主题",
    "interfaceDisplay": "界面显示",
    "layout": "布局",
    "localeIcon": "多语言图标",
    "logo": "标志",
    "menuTheme": "菜单主题",
    "projectSetting": "项目配置",
    "reExperienced": "请重新退出登录体验",
    "screenfullIcon": "全屏图标",
    "serverDynamicRouter": "服务端动态路由",
    "sizeIcon": "尺寸图标",
    "systemTheme": "系统主题",
    "tagsView": "标签页",
    "tagsViewIcon": "标签页图标",
    "theme": "主题",
    "uniqueOpened": "菜单手风琴"
  },
  "settingsManagement": {
    "operationLogManagement": {
      "businessType": {
        "add": "新增",
        "delete": "删除",
        "login": "登录",
        "logout": "登出",
        "unknown": "未知",
        "update": "修改"
      },
      "dialog": {
        "basicInfo": "基本信息",
        "requestInfo": "请求信息",
        "responseInfo": "响应信息",
        "title": "日志详情"
      },
      "logType": {
        "error": "错误",
        "info": "信息",
        "warning": "警告"
      },
      "messages": {
        "loadDataFailed": "加载日志数据失败"
      },
      "searchForm": {
        "browser": "浏览器",
        "businessType": "业务类型",
        "dateRange": {
          "endPlaceholder": "结束日期",
          "label": "日期范围",
          "separator": "至",
          "startPlaceholder": "开始日期"
        },
        "operateIp": "操作IP",
        "operateName": "操作人",
        "operateUrl": "操作URL",
        "success": "成功状态",
        "systemOs": "操作系统",
        "title": "日志标题"
      },
      "table": {
        "address": "地址",
        "browser": "浏览器",
        "businessType": "业务类型",
        "errorMsg": "错误消息",
        "id": "ID",
        "logType": "日志类型",
        "operId": "操作人ID",
        "operateIp": "操作IP",
        "operateName": "操作人",
        "operateUrl": "操作URL",
        "operation": "操作",
        "requestBody": "请求体",
        "requestMethod": "请求方法",
        "requestParam": "请求参数",
        "responseBody": "响应体",
        "sign": "签名",
        "success": "状态",
        "systemOs": "操作系统",
        "time": "执行时间",
        "title": "日志标题",
        "viewDetail": "查看详情"
      },
      "title": "操作日志管理"
    },
    "roleManagement": {
      "addPermissionGroup": "添加权限组合包",
      "addPermissionGroupFailed": "添加权限组关联失败",
      "addPermissionGroupSuccess": "添加权限组合包成功",
      "addRole": "新增角色",
      "addRoleDialog": "新增角色",
      "agencyManagement": "机构管理",
      "availablePermissionGroups": "可用权限组合包",
      "branchAgent": "分公司代理商",
      "branchAgentAdmin": "分公司代理商管理员",
      "branchAgentAdminDesc": "分公司代理商管理员角色",
      "branchAgentOperator": "分公司代理商操作员",
      "branchAgentOperatorDesc": "分公司代理商操作员角色",
      "buttonPermissions": "按钮权限",
      "buttons": "按钮",
      "confirmDeleteMessage": "确定要删除角色 \"{name}\" 吗？",
      "confirmDeleteRole": "确认删除",
      "confirmDeleteRoleMessage": "确定要删除角色 \"{roleName}\" 吗？",
      "createFailed": "创建失败",
      "createSuccess": "创建成功",
      "currentMenu": "当前菜单",
      "customer": "客户",
      "customerAdmin": "客户管理员",
      "customerAdminDesc": "客户级管理员角色",
      "customerFinance": "客户财务",
      "customerFinanceDesc": "客户财务角色",
      "customerOperator": "客户操作员",
      "customerOperatorDesc": "客户操作员角色",
      "deleteFailed": "删除失败",
      "deleteRole": "删除角色",
      "deleteRoleFailed": "删除角色失败",
      "deleteRoleSuccess": "删除角色成功",
      "deleteSuccess": "删除成功",
      "editRole": "编辑角色",
      "enterGroupName": "输入组合包名称",
      "enterGroupType": "输入组合包类型",
      "factory": "工厂",
      "factoryAdmin": "工厂管理员",
      "factoryAdminDesc": "工厂级管理员角色",
      "factoryAgent": "工厂代理商",
      "factoryAgentAdmin": "工厂代理商管理员",
      "factoryAgentAdminDesc": "工厂代理商管理员角色",
      "factoryAgentOperator": "工厂代理商操作员",
      "factoryAgentOperatorDesc": "工厂代理商操作员角色",
      "factoryInspector": "工厂质检员",
      "factoryInspectorDesc": "工厂质检员角色",
      "factoryOperator": "工厂操作员",
      "factoryOperatorDesc": "工厂操作员角色",
      "groupCode": "组合包编码",
      "groupName": "组合包名称",
      "groupType": "组合包类型",
      "help": {
        "parentRole": "上级角色，新的角色将继承上级角色的层级结构；仅新增角色时可选",
        "remark": "角色备注信息，可用于记录角色职责或使用说明",
        "roleName": "角色的显示名称，用于在系统中区分不同角色，建议长度2-100个字符",
        "roleType": "角色所属的类别，不同类型决定了角色的层级与权限范围"
      },
      "loadButtonDataError": "加载按钮数据失败",
      "loadMenuTreeError": "加载菜单树失败",
      "loadParentRoleTreeError": "加载上级角色树失败",
      "loadPermissionGroupListError": "加载权限组合包列表失败",
      "loadRoleAuthError": "加载角色权限失败",
      "loadRolePermissionGroupsError": "加载角色权限组合包失败",
      "loadRoleTreeError": "加载角色树失败",
      "loadingRoleTree": "正在加载角色树...",
      "menuButtonPermissions": "菜单和按钮权限",
      "menuPermissions": "菜单权限",
      "menus": "菜单",
      "noAvailablePermissionGroups": "暂无可添加的权限组合包",
      "noButtonsForMenu": "该菜单暂无按钮权限",
      "noPermissionGroups": "暂未配置权限组合包",
      "operationManagement": "运营管理",
      "parentRole": "上级角色",
      "permissionDetails": "权限详情",
      "permissionGroupAlreadyAssociated": "该权限组已经关联到当前角色",
      "permissionGroupList": "权限组合包列表",
      "permissionGroupPackages": "权限组合包",
      "permissionPreview": "权限预览",
      "permissionSettings": "权限设置",
      "plat": "运营",
      "platAdmin": "运营管理员",
      "platAdminDesc": "运营级管理员角色",
      "platAuditor": "运营审核员",
      "platAuditorDesc": "运营审核员角色",
      "platSpecialist": "运营专员",
      "platSpecialistDesc": "运营专员角色",
      "pleaseSelectMenu": "请先选择菜单",
      "previewPermissions": "预览权限",
      "remove": "移除",
      "removePermissionGroupFailed": "删除权限组关联失败",
      "removePermissionGroupSuccess": "移除权限组合包成功",
      "roleList": "角色列表",
      "roleManagement": "角色管理",
      "roleName": "角色名称",
      "roleType": "角色类型",
      "savePermissions": "保存权限",
      "savePermissionsFailed": "权限保存失败",
      "savePermissionsSuccess": "权限保存成功",
      "selectPermissionGroup": "选择权限组合包",
      "selectRoleFirst": "请先选择角色",
      "systemManagement": "系统管理",
      "title": "角色管理",
      "updateFailed": "更新失败",
      "updateSuccess": "更新成功",
      "userManagement": "用户管理",
      "viewPermissions": "查看权限"
    },
    "userManagement": {
      "addOperator": "新增操作员",
      "addOperatorDialog": "新增操作员",
      "backupEmail": "备用邮箱",
      "belongingOrg": "所属机构",
      "companyName": "公司名称",
      "confirmDeleteMessage": "确定要删除操作员 \"{name}\" 吗？",
      "confirmDisable": "确认禁用",
      "confirmDisableMessage": "确定要禁用操作员 \"{name}\" 吗？",
      "confirmEnable": "确认启用",
      "confirmEnableMessage": "确定要启用操作员 \"{name}\" 吗？",
      "confirmPassword": "确认密码",
      "confirmReset": "确认重置",
      "createFailed": "创建失败",
      "createSuccess": "创建成功",
      "customer": "客户",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "disableSuccess": "禁用成功",
      "editOperator": "编辑操作员",
      "email": "邮箱",
      "enableSuccess": "启用成功",
      "factory": "工厂",
      "firstName": "名字",
      "help": {
        "backupEmail": "备用邮箱，可在主邮箱不可用时接收通知或找回账号",
        "belongingOrg": "选择操作员所属机构，不同机构决定可访问的数据范围",
        "companyName": "操作员所在公司的公司名或部门名，方便识别来源",
        "confirmPassword": "再次输入新密码，确保与上方输入保持一致",
        "email": "操作员主要邮箱，用于接收通知与重置密码等重要信息",
        "firstName": "操作员的名字信息，可用于展示和通知",
        "lastName": "操作员的姓氏信息，可用于邮件或通知中的正式称呼",
        "loginAccount": "登录账号，用于系统登录，支持字母、数字与下划线，长度3-100个字符",
        "mobile": "操作员手机号，用于联系与安全验证，建议填写常用号码",
        "newPassword": "重置密码时填写的新密码，须满足系统的最小长度要求",
        "operatorName": "操作员在系统中的显示名称，建议使用实名或岗位称谓，长度2-100个字符",
        "password": "初始登录密码，仅新增操作员时必填，建议6-255位并包含数字与字母",
        "role": "为操作员分配角色，角色定义了可访问的菜单以及按钮权限",
        "status": "操作员状态，禁用后将无法登录系统或执行任何操作",
        "titleLabel": "操作员的职位或头衔，例如经理、客服等"
      },
      "lastName": "姓氏",
      "loadOrgTreeFailed": "加载机构树失败",
      "loadOperatorsFailed": "加载操作员数据失败",
      "loadingOrgTree": "正在加载机构树...",
      "loginAccount": "登录账号",
      "mobile": "手机号",
      "newPassword": "新密码",
      "operationFailed": "操作失败",
      "operatorList": "操作员列表",
      "operatorName": "操作员名称",
      "org": "机构",
      "orgList": "机构列表",
      "password": "密码",
      "plat": "运营总部",
      "resetPassword": "重置密码",
      "resetPasswordDialog": "重置密码",
      "resetPasswordFailed": "密码重置失败",
      "resetPasswordSuccess": "密码重置成功",
      "role": "角色",
      "searchOrg": "搜索机构...",
      "title": "系统用户管理",
      "titleLabel": "称谓",
      "updateFailed": "更新失败",
      "updateSuccess": "更新成功"
    }
  },
  "size": {
    "default": "默认",
    "large": "大",
    "small": "小"
  },
  "systemManagement": {
    "countryManagement": {
      "addCountry": "新增国家",
      "addCountryDialog": "新增国家",
      "addFailed": "新增国家失败",
      "addSuccess": "新增国家成功",
      "commaSeparator": "逗号 (,)",
      "confirmDeleteMessage": "确定要删除国家 \"{countryName}\" 吗？",
      "countryCode": "国家编码",
      "countryCodeLabel": "国家编码",
      "countryName": "国家名称",
      "countryNameLabel": "国家名称",
      "culture": "文化",
      "cultureCode": "文化代码",
      "cultureCodePlaceholder": "如：zh-CN, en-US",
      "cultureCodeTip": "用于标识此文化配置的唯一代码",
      "cultureLabel": "文化",
      "cultureOptions": {
        "ar_SA": "沙特阿拉伯：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号﷼",
        "de_DE": "德国：日期格式DD.MM.YYYY，数字分隔符千分位，货币符号€",
        "en_GB": "英国：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号£",
        "en_US": "美国：日期格式MM/DD/YYYY，数字分隔符千分位，货币符号$",
        "es_ES": "西班牙：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号€",
        "fr_FR": "法国：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号€",
        "hi_IN": "印度：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号₹",
        "id_ID": "印度尼西亚：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号Rp",
        "it_IT": "意大利：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号€",
        "ja_JP": "日本：日期格式YYYY年MM月DD日，数字分隔符千分位，货币符号¥",
        "ko_KR": "韩国：日期格式YYYY.MM.DD，数字分隔符千分位，货币符号₩",
        "ms_MY": "马来西亚：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号RM",
        "nl_NL": "荷兰：日期格式DD-MM-YYYY，数字分隔符千分位，货币符号€",
        "pl_PL": "波兰：日期格式DD.MM.YYYY，数字分隔符千分位，货币符号zł",
        "pt_PT": "葡萄牙：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号€",
        "ru_RU": "俄罗斯：日期格式DD.MM.YYYY，数字分隔符千分位，货币符号₽",
        "th_TH": "泰国：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号฿",
        "tr_TR": "土耳其：日期格式DD.MM.YYYY，数字分隔符千分位，货币符号₺",
        "vi_VN": "越南：日期格式DD/MM/YYYY，数字分隔符千分位，货币符号₫",
        "zh_CN": "中国：日期格式YYYY-MM-DD，数字分隔符千分位，货币符号¥"
      },
      "currency": "货币",
      "currencyPosition": "货币符号位置",
      "currencyPositionAfter": "后面 (100$)",
      "currencyPositionBefore": "前面 ($100)",
      "currencySymbol": "货币符号",
      "dateFormat": "日期格式",
      "dateSeparator": "日期分隔符",
      "dateSeparatorPlaceholder": "如：-, /, .",
      "dateTimeFormat": "日期时间格式",
      "defaultCurrencyCode": "默认货币编码",
      "defaultTimezone": "默认时区",
      "defaultTimezoneLabel": "默认时区",
      "decimalPlaces": "小数位数",
      "decimalSeparator": "小数分隔符",
      "deleteFailed": "删除国家失败",
      "deleteSuccess": "删除国家成功",
      "dotSeparator": "点号 (.)",
      "editCountry": "编辑国家",
      "editCountryDialog": "编辑国家",
      "help": {
        "countryCode": "国家/地区的唯一编码，建议使用 ISO 标准代码，创建后不可修改",
        "countryName": "国家/地区的显示名称，用于界面展示和搜索，支持多语言",
        "cultureCode": "文化标识，用于快速复用日期、数字、货币等格式，例如 zh-CN、en-US",
        "currency": "选择默认货币，系统会根据货币代码匹配符号和名称",
        "currencyPosition": "货币符号的位置，位于金额前或后",
        "currencySymbol": "货币符号，可自定义覆盖默认符号，例如 ¥ 或 $",
        "dateFormat": "日期显示格式，如 YYYY-MM-DD、MM/DD/YYYY 等，会影响所有日期展示",
        "dateSeparator": "日期中使用的分隔符，默认为格式中常见的 -、/ 或 .",
        "defaultCurrencyCode": "国家默认使用的货币编码，可从列表中选择，也可手动输入未在列表中的编码",
        "decimalPlaces": "默认保留的小数位数，用于金额或百分比显示",
        "decimalSeparator": "小数分隔符，通常为点（.）或逗号（,）",
        "language": "该国家对应的语言设置，会影响界面显示语言",
        "remark": "国家的备注信息，用于记录特殊说明或配置",
        "textDirection": "文本方向，从左到右 (ltr) 或从右到左 (rtl)",
        "thousandsSeparator": "千分位分隔符，用于数字分组显示",
        "timeFormat": "时间显示格式，支持 24 小时或 12 小时制",
        "timeFormatTemplate": "时间格式模板，可自定义展示形式，如 HH:mm:ss 或 h:mm:ss A",
        "timezone": "默认时区，用于时间显示和计算，可选择或手动输入"
      },
      "language": "语言",
      "languageLabel": "语言",
      "languageOptions": {
        "ar_SA": "العربية",
        "de_DE": "Deutsch",
        "en_GB": "English (UK)",
        "en_US": "English (US)",
        "es_ES": "Español",
        "fr_FR": "Français",
        "hi_IN": "हिन्दी",
        "id_ID": "Bahasa Indonesia",
        "it_IT": "Italiano",
        "ja_JP": "日本語",
        "ko_KR": "한국어",
        "ms_MY": "Bahasa Melayu",
        "nl_NL": "Nederlands",
        "pl_PL": "Polski",
        "pt_PT": "Português",
        "ru_RU": "Русский",
        "th_TH": "ไทย",
        "tr_TR": "Türkçe",
        "vi_VN": "Tiếng Việt",
        "zh_CN": "中文（简体）"
      },
      "languageTimezone": "语言时区",
      "loadDataFailed": "加载国家数据失败",
      "numberCurrencyFormat": "数字货币格式",
      "searchPlaceholder": "搜索国家编码或名称...",
      "spaceSeparator": "空格 ( )",
      "textDirection": "文本方向",
      "textDirectionLtr": "从左到右 (ltr)",
      "textDirectionRtl": "从右到左 (rtl)",
      "thousandsSeparator": "千分位分隔符",
      "timeFormat": "时间格式",
      "timeFormat12Hour": "12小时制 (h:mm:ss A)",
      "timeFormat24Hour": "24小时制 (HH:mm:ss)",
      "timeFormatTemplate": "时间格式模板",
      "timezone": "时区",
      "timezoneLabel": "时区",
      "timezoneOptions": {
        "UTC+0": "UTC+0 (伦敦时间)",
        "UTC+1": "UTC+1 (巴黎时间)",
        "UTC+10": "UTC+10 (悉尼时间)",
        "UTC+11": "UTC+11 (所罗门群岛时间)",
        "UTC+12": "UTC+12 (新西兰时间)",
        "UTC+2": "UTC+2 (开罗时间)",
        "UTC+3": "UTC+3 (莫斯科时间)",
        "UTC+5.5": "UTC+5.5 (新德里时间)",
        "UTC+7": "UTC+7 (曼谷时间)",
        "UTC+8": "UTC+8 (北京时间)",
        "UTC+9": "UTC+9 (东京时间)",
        "UTC-10": "UTC-10 (夏威夷时间)",
        "UTC-11": "UTC-11 (萨摩亚时间)",
        "UTC-3": "UTC-3 (巴西时间)",
        "UTC-4": "UTC-4 (委内瑞拉时间)",
        "UTC-5": "UTC-5 (纽约时间)",
        "UTC-6": "UTC-6 (墨西哥城时间)",
        "UTC-7": "UTC-7 (丹佛时间)",
        "UTC-8": "UTC-8 (洛杉矶时间)",
        "UTC-9": "UTC-9 (阿拉斯加时间)"
      },
      "title": "国家管理",
      "updateFailed": "编辑国家失败",
      "updateSuccess": "编辑国家成功",
      "viewCountry": "查看国家"
    },
    "currencyManagement": {
      "addCurrency": "新增币种",
      "addCurrencyDialog": "新增币种",
      "addFailed": "新增币种失败",
      "addSuccess": "新增币种成功",
      "confirmDeleteMessage": "确定要删除币种 \"{currencyName}\" 吗？",
      "currencyCode": "币种编码",
      "currencyCodeLabel": "币种编码",
      "currencyNumericCode": "币种数字代码",
      "currencyNumericCodeLabel": "币种数字代码",
      "currencyName": "币种名称",
      "currencyNameLabel": "币种名称",
      "currencySymbol": "币种符号",
      "currencySymbolLabel": "币种符号",
      "decimalPlace": "小数位数",
      "decimalPlaceLabel": "小数位数",
      "deleteFailed": "删除币种失败",
      "deleteSuccess": "删除币种成功",
      "editCurrencyDialog": "编辑币种",
      "help": {
        "currencyCode": "货币的唯一编码，通常遵循ISO 4217标准（如USD、EUR、CNY），创建后不可修改，长度1-50个字符",
        "currencyNumericCode": "货币的数字代码，必须为 3 位数字，允许 0-9 任意数字组合，如 156、840、978",
        "currencyName": "货币的显示名称，用于在系统中标识货币，如美元、欧元、人民币等，长度1-100个字符",
        "currencySymbol": "货币的符号表示，如$、€、¥等，用于在界面中显示货币金额，长度不超过20个字符",
        "decimalPlace": "货币金额显示时保留的小数位数，可选 0、1、2，默认值为 0"
      },
      "loadDataFailed": "加载币种数据失败",
      "searchPlaceholder": "搜索币种编码或名称...",
      "title": "币种管理",
      "updateFailed": "编辑币种失败",
      "updateSuccess": "编辑币种成功",
      "validation": {
        "currencyNumericCodeFormat": "币种数字代码必须为 3 位数字"
      }
    },
    "deviceConfigTemplate": {
      "addDialogTitle": "添加设备配置模板",
      "addFailed": "添加失败",
      "addField": "添加字段",
      "addSuccess": "添加成功",
      "configJsonLabel": "配置JSON",
      "confirmDeleteMessage": "确定要删除此设备配置模板吗？",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "disable": "禁用",
      "editDialogTitle": "编辑设备配置模板",
      "help": {
        "configJson": "设备配置模板的配置信息，以JSON格式存储",
        "status": "设备配置模板的状态，正常或禁用",
        "templateName": "设备配置模板的显示名称，用于标识模板",
        "templateType": "设备配置模板的类型代码，用于关联设备模块"
      },
      "jsonPreview": "JSON预览",
      "keyName": "键名称",
      "loadDataFailed": "加载数据失败",
      "loadDeviceModelFailed": "加载设备模块失败",
      "normal": "正常",
      "searchByTemplateName": "按模板名称搜索",
      "statusLabel": "状态",
      "submitFailed": "提交失败",
      "templateName": "模板名称",
      "templateNameLabel": "模板名称",
      "templateNo": "模板编号",
      "templateType": "模板类型",
      "templateTypeLabel": "模板类型",
      "title": "设备配置模板",
      "updateFailed": "更新失败",
      "updateSuccess": "更新成功"
    },
    "deviceManagement": {
      "NetAccessError": "入网异常",
      "NetAccessSuccess": "第一次入网成功",
      "activePulse": "激活脉冲",
      "addConfig": "新增配置",
      "addConfigDialog": "新增配置",
      "addDevice": "新增设备",
      "addMqtt": "添加MQTT",
      "addPaySource": "添加支付源",
      "addSuccess": "添加成功",
      "addWifi": "添加WIFI",
      "apn": "APN",
      "apnPlaceholder": "如: cmnet",
      "appVersion": "应用版本",
      "appVersionPlaceholder": "如: 1.0.1",
      "assignedMachine": "机器关联状态",
      "boundMachine": "绑定机器",
      "authPassword": "管理密码",
      "authPasswordConfig": "管理密码",
      "baseConfigPush": "基础配置下发",
      "batchAddDevices": "批量新增设备",
      "batchCreateFailed": "批量创建失败",
      "batchCreateSuccess": "批量创建成功",
      "belongingOrg": "所属机构",
      "bindTime": "绑定时间",
      "bindMachine": "绑定机器",
      "bindMachineDialogTitle": "绑定机器",
      "bindMachineFailed": "绑定机器失败",
      "bindMachineSuccess": "绑定机器成功",
      "bindingRecord": "设备绑定记录",
      "bluetooth": "蓝牙",
      "bootVersion": "引导版本",
      "bootVersionPlaceholder": "如: 1.0.22",
      "ccid": "设备SIM卡ID",
      "cid": "CID",
      "coin": "硬币",
      "coinType": "币种类型",
      "collapse": "收起",
      "commConfig": "通讯配置",
      "commandDescription": "指令描述",
      "commandDescriptionLabel": "指令描述",
      "commandDetail": "指令详情",
      "commandGetConfig": "GetConfig - 获取设备配置",
      "commandLog": "Log - 设置日志等级",
      "commandReboot": "Reboot - 设备重启",
      "commandRecord": "指令记录",
      "commandRestart": "Restart - boot重启",
      "commandSendFailed": "指令发送失败",
      "commandSendRecord": "指令下发记录",
      "commandSendSuccess": "指令发送成功",
      "commandSleep": "Sleep - 休眠",
      "commandSyncTime": "Synchronize time - 同步时间",
      "commandType": "指令类型",
      "commandTypeLabel": "指令类型",
      "communicationConfig": "通讯配置",
      "configContent": "配置内容",
      "configContentLabel": "配置内容",
      "configDownload": "配置下发",
      "configEmptyTip": "设备配置为空，请先配置",
      "configManagement": "配置管理",
      "configTemplate": "配置模板",
      "configType": "配置类型",
      "configTypeLabel": "配置类型",
      "confirmAction": "确认操作",
      "confirmFetchLogMessage": "确定要发起设备 {sn} 的日志拉取吗？",
      "confirmDeleteConfigMessage": "确定要删除该配置吗？",
      "confirmDeleteMessage": "确定要删除该设备吗？",
      "confirmRebootMessage": "确定要重启该设备吗？",
      "confirmRestartBootMessage": "确定要重启引导该设备吗？",
      "confirmUnbind": "确认解绑",
      "confirmUnbindMessage": "确定要解绑此设备{name}吗？解绑后可以进行转移操作。",
      "creator": "创建人",
      "deleteConfig": "删除",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "deviceAlreadyBoundMessage": "该设备已绑定，是否解绑并转移？",
      "deviceCommandSend": "设备指令发送",
      "deviceConfig": "设备配置",
      "deviceCount": "设备数量",
      "deviceModel": "设备型号",
      "deviceModelPlaceholder": "如: VP10",
      "deviceName": "设备名称",
      "deviceProvider": "设备提供商",
      "communicationModule": "通信模块",
      "deviceSN": "设备序列号",
      "deviceSNPlaceholder": "如: VP10250907610001",
      "deviceSource": "设备来源",
      "deviceSourceInside": "内部设置",
      "deviceSourceOutside": "外部设备",
      "deviceInfoQr": "设备信息二维码",
      "qrCodeDialogTitle": "设备信息二维码",
      "qrCodeLink": "链接",
      "qrCodeImage": "二维码",
      "qrCodeGenerating": "生成二维码中...",
      "noQrCodeLink": "暂无链接可复制",
      "copySuccess": "复制成功",
      "copyFailed": "复制失败",
      "generateQrCodeLinkFailed": "生成二维码链接失败",
      "generateQrCodeImageFailed": "生成二维码图片失败",
      "deviceInfoQrNoDevice": "请先保存设备后再生成二维码",
      "deviceType": "设备型号",
      "device_batchRegister": "批量注册设备",
      "dialnum": "拨号号码",
      "dialnumPlaceholder": "默认: *99***3#",
      "displaySupport": "显示屏支持",
      "downloadConfig": "下发配置",
      "downloadExample": "下载范例文件",
      "downloadFailed": "下载失败",
      "downloadSuccess": "下载成功",
      "downloadTip": "下载范例文件并按照格式填写设备信息后上传",
      "downloadingExample": "正在下载范例文件...",
      "duplicateConfigType": "该设备已存在相同类型的配置，每种配置类型只能有一条记录",
      "editConfigDialog": "编辑配置",
      "enterAuthPassword": "请输入管理密码",
      "enterCID": "请输入CID",
      "enterDialNum": "请输入拨号号码",
      "enterMQTTIP": "请输入MQTT IP",
      "enterMQTTPassword": "请输入MQTT密码",
      "enterMQTTUser": "请输入MQTT用户名",
      "enterPIN": "请输入PIN",
      "enterPassword": "请输入密码",
      "enterTransferRemark": "请输入转移原因",
      "enterUsername": "请输入用户名",
      "enterWifiPassword": "请输入WiFi密码",
      "enterWifiPassword2": "请输入WiFi密码二",
      "enterWifiSSID": "请输入WiFi名称",
      "enterWifiSSID2": "请输入WiFi名称二",
      "exampleFile": "设备批量导入范例.xlsx",
      "expand": "展开",
      "extendConfigPush": "业务配置下发",
      "fourGConfig": "4G配置",
      "fourGEnable": "4G启用",
      "fourGSupport": "4G支持",
      "hardwareConfig": "硬件配置",
      "hardwareSupportHint": "0不支持 / >1支持",
      "help": {
        "apn": "4G网络的APN（接入点名称），用于配置4G网络的接入点，如cmnet、3gnet等",
        "appVersion": "设备上报的应用版本号，用于展示当前终端运行的软件版本，不可手动修改",
        "belongingOrg": "设备所属的机构，决定了设备的数据访问权限和管理范围",
        "cid": "4G网络的CID（连接标识符），范围0-65535，用于标识4G网络连接",
        "commandDescription": "指令的描述信息，用于说明发送该指令的目的或原因，可选填写",
        "commandType": "要发送的指令类型，如重启、休眠、同步时间、设置日志等级等",
        "configType": "配置的类型，如WiFi配置、4G配置等，每种类型只能有一条配置记录",
        "communicationModule": "设备使用的通信模块信息，如4G、5G、WiFi或以太网等，用于标识设备通信能力",
        "deviceName": "设备的显示名称，用于在系统中标识设备，支持从预设选项中选择或自定义输入",
        "deviceProvider": "设备的制造商或提供商名称，用于标识设备来源",
        "deviceSource": "设备的来源类型，内部设置表示由系统内部创建，外部设备表示由外部系统导入",
        "deviceInfoQr": "扫码查看设备信息页面",
        "deviceType": "设备的类型代码，决定了设备的功能特性和业务规则，必须从设备类型列表中选择",
        "dialnum": "4G网络的拨号号码，用于建立4G连接，默认为*99#",
        "fourGEnable": "4G网络开关，开启后设备将使用4G网络连接，关闭时自动启用WiFi网络",
        "moduleType": "设备的通信模块类型，如4G、5G、WiFi、蓝牙等，决定了设备的网络连接方式",
        "password": "4G网络的密码，用于4G网络认证，长度8-16个字符",
        "pin": "4G SIM卡的PIN码，4位数字，用于保护SIM卡安全",
        "remark": "设备的备注信息，用于记录额外的说明或备注",
        "serialNumber": "设备的唯一序列号，用于标识物理设备，创建后不可修改",
        "serialNumberPattern": "只能输入字母和数字",
        "status": "设备的运行状态，测试中表示设备处于测试阶段，激活表示设备可正常使用，未激活表示设备已停用",
        "systemDeviceNo": "系统自动生成的设备编号，用于系统内部识别和管理，不可手动修改",
        "toOrgLabel": "目标机构，设备将被转移到该机构下",
        "transferReason": "转移原因，用于解释转移设备的原因",
        "username": "4G网络的用户名，用于4G网络认证，长度1-20个字符",
        "wifiEnable": "WiFi网络开关，开启后设备将使用WiFi网络连接，关闭时自动启用4G网络",
        "wifiPassword": "WiFi网络的密码，用于连接WiFi网络，长度8-63个字符",
        "wifiSSID": "WiFi网络的SSID（服务集标识符），用于标识WiFi网络，长度1-32个字符，支持字母、数字、下划线和连字符"
      },
      "hwConfig": "硬件配置",
      "inactivePulse": "非激活脉冲",
      "lastOfflineTime": "最后离线时间",
      "lastOnline": "最后在线",
      "lastOnlineNetType": "最后上线网络类型",
      "lastOnlineWifiSsid": "最后上线 WiFi SSID",
      "lastOnlineTime": "最后上线时间",
      "netStatus": "连接状态",
      "loadBindingRecordsFailed": "加载设备绑定记录失败",
      "loadBindableMachinesFailed": "加载可绑定机器失败",
      "loadCommandLogsFailed": "加载指令记录失败",
      "loadConfigFailed": "加载配置失败",
      "loadConfigsFailed": "加载设备配置失败",
      "loadDeviceDataFailed": "加载设备数据失败",
      "loadDeviceTypesFailed": "加载设备类型失败",
      "loadOrgDevicesFailed": "加载机构设备失败",
      "loadOrgTreeFailed": "加载机构树失败",
      "loadingOrgDeviceTree": "正在加载机构设备树...",
      "loadTemplatesFailed": "加载模板失败",
      "log": "日志",
      "logClose": "关闭",
      "logError": "错误",
      "logInfo": "信息",
      "logLevel": "日志等级",
      "logLevelClose": "0 - 关闭",
      "logLevelError": "4 - Error",
      "logLevelInfo": "2 - Info",
      "logLevelTrace": "1 - Trace",
      "logLevelWarn": "3 - Warn",
      "lottieAssetsUploadComplete": "Lottie动画资源上传完成",
      "lottieAssetsUploadTip": "检测到Lottie动画包含外部图片资源，请按顺序上传对应的图片文件",
      "lottieHasExternalAssets": "检测到Lottie动画包含外部图片资源，建议使用Base64内联图片的Lottie文件以确保正常显示",
      "machineConfig": "Machine配置",
      "machineConfigAutoDispatch": "PULSE协议保存成功，末端配置已自动下发",
      "machineConfigDispatchFailed": "PULSE协议保存成功，但末端配置下发失败",
      "machineConfigExistsPrompt": "该设备已存在末端配置（machine.cfg），是否更新现有配置？",
      "machineConfigUpdateSuccess": "末端配置已更新",
      "machineName": "机器名称",
      "moduleType": "模块类型",
      "mqttConfig": "MQTT配置",
      "mqttIP": "IP地址",
      "mqttIPPlaceholder": "如: 192.168.1.100",
      "mqttKeepalive": "保活时间",
      "mqttKeepalivePlaceholder": "60",
      "mqttPassword": "密码",
      "mqttPasswordPlaceholder": "8-16位",
      "mqttPort": "端口",
      "mqttPortPlaceholder": "1883",
      "mqttQos": "QoS",
      "mqttUser": "用户名",
      "mqttUserPlaceholder": "1-20位",
      "netAccessStatus": "第一次入网状态",
      "netAccessTime": "第一次入网时间",
      "netCombineError": "集成入网异常",
      "netCombineStatus": "集成入网状态",
      "netCombineSuccess": "集成入网成功",
      "netCombineTime": "集成入网时间",
      "noAvailableConfigType": "该设备所有配置类型均已添加，无可新增类型",
      "noCommandHistory": "暂无指令历史",
      "noConfigHistory": "暂无配置历史",
      "noMachineConfig": "暂无Machine配置",
      "noTransferOrg": "暂无可选择的目标机构",
      "notNetAccess": "未入网",
      "notNetCombine": "未集成入网",
      "notRegistered": "未注册",
      "notSupport": "不支持",
      "notSupported": "不支持",
      "off": "关闭",
      "on": "开启",
      "onlyImageOrJsonFiles": "只能上传图片文件或Lottie动画JSON文件",
      "operateTime": "操作时间",
      "operatorName": "操作人",
      "optional": "可选",
      "orgDeviceTree": "机构设备树",
      "orgName": "机构名称",
      "osVersion": "系统版本",
      "osVersionPlaceholder": "如: 5.0.21",
      "paper": "纸币",
      "parseTemplateFailed": "解析模板失败",
      "password": "密码",
      "passwordPlaceholder": "8-16位",
      "paySource": "支付源配置",
      "pin": "PIN",
      "pinPlaceholder": "4位数字",
      "pleaseSelectDevice": "请先选择一个设备",
      "pleaseUploadAllAssets": "请上传所有资源后再确认",
      "port": "端口",
      "professionalMode": "专业模式",
      "pulseConfig": "脉冲配置",
      "pulseCount": "脉冲数",
      "pushConfig": "配置下发",
      "pushConfigFailed": "配置下发失败",
      "pushConfigSuccess": "配置下发成功",
      "downloadDeviceLog": "下载日志",
      "fetchLog": "拉取日志",
      "fetchLogFail": "拉取失败",
      "fetchLogMessage": "拉取结果",
      "fetchLogRecord": "拉取日志记录",
      "fetchLogDeviceOffline": "设备离线，无法发起拉取日志",
      "fetchLogStarted": "已发起拉取日志",
      "fetchLogStartFailed": "发起拉取日志失败",
      "fetchLogSuccess": "成功",
      "fetchLogSuccessMessage": "设备日志拉取成功",
      "fetchLogReload": "重新加载",
      "fetchLogDownloading": "获取日志中...",
      "fetchLogDownloadFailed": "日志下载失败",
      "fetchLogDownloadMissing": "设备日志文件不存在或已过期删除",
      "fetchLogUrlMissing": "日志下载地址缺失",
      "fetchingLog": "获取日志中",
      "loadFetchLogRecordsFailed": "加载拉取日志记录失败",
      "qosAtLeastOnce": "1 - 至少一次",
      "qosAtMostOnce": "0 - 最多一次",
      "qosExactlyOnce": "2 - 恰好一次",
      "reRegister": "重新注册",
      "reRegisterFailed": "重新注册失败",
      "reRegisterSuccess": "重新注册成功",
      "reboot": "设备重启",
      "rebootCommandSent": "重启指令已发送",
      "register": "注册",
      "registerStatus": "注册状态",
      "registerSuccess": "注册成功",
      "removeMqtt": "删除",
      "removePaySource": "删除",
      "removeWifi": "删除",
      "requestJson": "请求JSON",
      "requestParams": "请求参数",
      "requestParamsLabel": "请求参数",
      "responseJson": "响应JSON",
      "responseResult": "响应结果",
      "restartBoot": "重启",
      "restartBootCommandSent": "重启引导指令已发送",
      "resultStatus": "结果状态",
      "rssi": "信号强度",
      "saveAuthConfigSuccess": "保存管理密码成功",
      "saveConfigFailed": "保存配置失败",
      "saveFailed": "保存失败",
      "saveFourGConfigSuccess": "保存4G配置成功",
      "saveMqttConfigSuccess": "保存MQTT配置成功",
      "savePulseConfigSuccess": "保存末端通信配置成功",
      "saveSuccess": "保存成功",
      "saveWifiConfigSuccess": "保存WiFi配置成功",
      "searchPlaceholder": "搜索机构或设备",
      "selectAPN": "选择APN",
      "selectDateTime": "选择日期时间",
      "selectDeviceFirst": "请先选择一个设备",
      "selectFile": "选择文件",
      "selectFileFirst": "请先选择文件",
      "selectOrgFirst": "请先选择机构",
      "selectOrgOrDevice": "请选择设备",
      "selectQOS": "选择QOS",
      "selectSourceOrgName": "选择来源机构名称",
      "selectTargetOrg": "请选择目标机构",
      "selectTemplate": "选择模板",
      "send": "发送",
      "sendCommand": "发送指令",
      "sendCommandDialog": "发送指令",
      "sendCommandFailed": "指令发送失败",
      "sendCommandSuccess": "指令发送成功",
      "serialNumber": "序列号",
      "sleep": "休眠",
      "sn": "SN",
      "sourceDeviceType": "来源设备型号",
      "sourceOrgName": "来源机构名称",
      "status": "状态",
      "statusActive": "激活",
      "statusTest": "测试中",
      "statusUnActive": "未激活",
      "supported": "支持",
      "syncTime": "同步时间",
      "synchronizeTime": "同步时间",
      "sysConfig": "系统配置",
      "sysDeviceNo": "系统设备号",
      "systemDeviceNo": "系统设备号",
      "targetOrgName": "目标机构名称",
      "terminalCommunicationConfig": "末端通信配置",
      "title": "设备管理",
      "toOrgLabel": "目标机构",
      "transferDevice": "转移设备",
      "transferFailed": "设备转移失败",
      "transferReason": "转移原因",
      "transferRecord": "转移记录",
      "transferSuccess": "设备转移成功",
      "confirmUnbindMachineMessage": "确定要解绑机器 {name} 吗？",
      "selectMachinePlaceholder": "请输入并选择机器",
      "unbindFailed": "设备解绑失败",
      "unbindMachine": "解绑机器",
      "unbindSuccess": "设备解绑成功",
      "unbindTime": "解绑时间",
      "unitValue": "面值",
      "updateSuccess": "更新成功",
      "upload": "上传",
      "uploadExcelOnly": "只能上传Excel或CSV文件！",
      "uploadFile": "上传文件",
      "uploadFileSizeLimit": "文件大小不能超过2MB！",
      "uploadLottieAssets": "上传Lottie动画资源",
      "uploadTip": "请上传Excel或CSV格式的文件，大小不超过2MB",
      "uploaded": "已上传",
      "viewMachine": "查看机器",
      "viewMachinePending": "查看机器详情暂未实现",
      "username": "用户名",
      "usernamePlaceholder": "1-20位",
      "vcoin": "虚拟币",
      "wifiConfig": "WiFi配置",
      "wifiEnable": "WiFi启用",
      "wifiPassword": "WiFi密码",
      "wifiPassword2": "WiFi密码二",
      "wifiPasswordPlaceholder": "8-63位",
      "wifiSSID": "WiFi名称",
      "wifiSSID2": "WiFi名称二",
      "wifiSSIDPlaceholder": "1-32位，字母/数字/下划线/连字符",
      "wifiSupport": "WiFi支持",
      "wlBand": "4G频段",
      "wlStandard": "4G制式"
    },
    "deviceModelConfig": {
      "addDialogTitle": "添加设备模块配置",
      "addFailed": "添加失败",
      "addKeyValue": "添加键值对",
      "addSuccess": "添加成功",
      "configJson": "配置JSON",
      "configJsonLabel": "配置JSON",
      "confirmDeleteMessage": "确定要删除此设备模块配置吗？",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "description": "描述",
      "editDialogTitle": "编辑设备模块配置",
      "exampleValue": "示例值",
      "help": {
        "configJson": "设备模块的配置信息，以JSON格式存储",
        "modelName": "设备模块的显示名称，用于标识设备模块",
        "modelType": "设备模块的类型代码，用于区分不同类型的设备模块"
      },
      "jsonPreview": "JSON预览",
      "keyName": "键名称",
      "loadDataFailed": "加载数据失败",
      "modelName": "模块名称",
      "modelNameLabel": "模块名称",
      "modelType": "模块类型",
      "modelTypeLabel": "模块类型",
      "submitFailed": "提交失败",
      "title": "设备模块配置",
      "updateFailed": "更新失败",
      "updateSuccess": "更新成功"
    },
    "deviceTagManagement": {
      "addFailed": "新增标签失败",
      "addSuccess": "新增标签成功",
      "addTag": "新增标签",
      "confirmDeleteMessage": "确定要删除标签 \"{tagName}\" 吗？",
      "deleteFailed": "删除标签失败",
      "deleteSuccess": "删除标签成功",
      "editTag": "编辑标签",
      "help": {
        "tagName": "设备标签的名称，用于在前端展示和筛选，建议控制在100个字符以内"
      },
      "loadDataFailed": "加载标签数据失败",
      "orgId": "机构ID",
      "tagName": "标签名称",
      "tagNameLabel": "标签名称",
      "title": "机器标签管理",
      "updateFailed": "编辑标签失败",
      "updateSuccess": "编辑标签成功"
    },
    "deviceTransferLog": {
      "batchNo": "转移批次号",
      "endTime": "结束时间",
      "loadDataFailed": "加载数据失败",
      "noErrorMessage": "无失败原因",
      "orgChange": "机构变更记录",
      "selectEndTime": "选择结束时间",
      "selectStartTime": "选择开始时间",
      "startTime": "开始时间",
      "transferReason": "转移原因",
      "transferResult": "转移结果"
    },
    "deviceTypeManagement": {
      "addFailed": "新增设备类型失败",
      "addSuccess": "新增设备类型成功",
      "addTypeDialog": "新增设备类型",
      "confirmDeleteMessage": "确定要删除类型 \"{typeName}\" 吗？",
      "deleteFailed": "删除设备类型失败",
      "deleteSuccess": "删除设备类型成功",
      "editTypeDialog": "编辑设备类型",
      "help": {
        "remark": "设备类型的备注信息，可用于记录该类型的特性、用途或使用说明，最大255个字符",
        "typeCode": "设备类型的唯一编码，用于在系统中标识设备类型，建议使用字母或数字组合，长度1-100个字符",
        "typeName": "设备类型的显示名称，用于在系统中区分不同类型的设备，长度1-100个字符"
      },
      "loadDataFailed": "加载设备类型数据失败",
      "title": "设备类型管理",
      "typeCode": "类型编码",
      "typeCodeLabel": "类型编码",
      "typeName": "类型名称",
      "typeNameLabel": "类型名称",
      "updateFailed": "编辑设备类型失败",
      "updateSuccess": "编辑设备类型成功"
    },
    "otaManagement": {
      "title": "OTA文件管理",
      "uploadNewFile": "上传新文件",
      "index": "序号",
      "fileName": "文件名",
      "fileSize": "文件大小",
      "uploadTime": "上传时间",
      "deviceList": "设备列表",
      "selectedFile": "已选文件：",
      "noFileSelected": "未选择升级的文件",
      "deviceSN": "设备序列号",
      "netStatus": "在线状态",
      "orgName": "所在机构名称",
      "selectOrgName": "请选择所在机构",
      "updateFile": "升级文件",
      "uploadSuccess": "上传成功",
      "uploadFailed": "上传失败",
      "onlySupport": "仅支持 .rbl, .tpk, .p1z 格式文件",
      "dangerousFileNotAllowed": "不允许上传可执行文件等危险文件格式",
      "getFileListFailed": "获取文件列表失败",
      "deleteSuccess": "删除成功",
      "deleteFailed": "删除失败",
      "getDeviceListFailed": "获取设备列表失败",
      "pleaseSelectFileFirst": "请先选择一个OTA文件",
      "updateCommandSent": "升级指令已下发",
      "updateFailed": "升级失败",
      "batchUpdate": "批量升级",
      "batchUpdateConfirm": "确认要批量升级这 {count} 台设备吗？",
      "selectedDeviceCount": "已选 {count} 台设备",
      "pleaseSelectAtLeastOneDevice": "请至少勾选一台设备",
      "batchUpdateMaxDevices": "最多只能选择10台设备进行批量升级",
      "batchUpdateSameDeviceType": "批量升级的设备型号必须一致",
      "batchUpdateOnlineOnly": "仅在线设备可参与批量升级",
      "batchUpdateSubmitted": "已提交 {count} 台设备的升级请求",
      "batchUpdatePartial": "部分升级成功，成功 {submitted} 台，失败 {failed} 台",
      "batchUpdateAllFailed": "批量升级提交失败",
      "batchUpdateFailed": "批量升级失败",
      "all": "全部",
      "noPermissionUpload": "没有上传ota文件权限",
      "noPermissionDelete": "没有删除ota文件权限",
      "noPermissionUpdate": "没有升级设备ota文件权限",
      "updateConfirm": "确定要向该设备下发升级指令吗？",
      "updateTypeTitle": "选择升级类型",
      "updateTypeApp": "App",
      "updateTypeWifiFw": "WiFi 固件包",
      "wifiFirmwareBinOnly": "WiFi 固件包必须是 .bin 文件",
      "refresh": "刷新",
      "fileSizeExceed": "上传文件大小不能超过 {size}MB",
      "updateLog": "升级日志",
      "updateLogList": "设备升级日志列表",
      "updateStatus": "升级状态",
      "updateMessage": "升级消息",
      "updateTime": "升级时间",
      "success": "成功",
      "fail": "失败",
      "updating": "升级中",
      "getLogFailed": "获取日志失败"
    },
    "dictionaryManagement": {
      "addDictDialog": "新增字典分类",
      "addFailed": "新增失败",
      "addItemDialog": "新增字典项",
      "addSuccess": "新增成功",
      "confirmDeleteDictMessage": "确定要删除字典分类 \"{dictText}\" 吗？",
      "confirmDeleteItemMessage": "确定要删除字典项 \"{itemText}\" 吗？",
      "deleteFailed": "删除失败",
      "deleteFailedMissingId": "删除失败：缺少ID",
      "deleteSuccess": "删除成功",
      "dictCategory": "字典分类",
      "dictCode": "字典编码",
      "dictCodeLabel": "字典编码",
      "dictItem": "字典项",
      "dictText": "字典名称",
      "dictTextLabel": "字典名称",
      "editDictDialog": "编辑字典分类",
      "editItemDialog": "编辑字典项",
      "help": {
        "dictCode": "字典分类的唯一编码，用于在系统中标识字典分类，创建后不可修改，长度1-60个字符",
        "dictText": "字典分类的显示名称，用于在系统中标识和展示字典分类，长度1-60个字符",
        "itemCode": "字典项的唯一编码，用于在系统中标识字典项，创建后不可修改，长度1-60个字符",
        "itemText": "字典项的显示名称，用于在系统中标识和展示字典项，长度1-60个字符"
      },
      "itemCode": "项编码",
      "itemCodeLabel": "项编码",
      "itemText": "项名称",
      "itemTextLabel": "项名称",
      "loadDictDataFailed": "加载字典分类数据失败",
      "loadItemDataFailed": "加载字典项数据失败",
      "title": "字典管理",
      "updateFailed": "编辑失败",
      "updateSuccess": "编辑成功"
    },
    "machineTypeManagement": {
      "addConfigItem": "添加配置项",
      "addConfigSection": "添加配置区块",
      "addFailed": "新增机器类型失败",
      "addSuccess": "新增机器类型成功",
      "addTypeDialog": "新增机器类型",
      "config": "配置",
      "configItems": "配置项",
      "configSection": "配置区块",
      "configSectionLabel": "配置区块",
      "confirmDeleteMessage": "确定要删除类型 \"{typeName}\" 吗？",
      "deleteFailed": "删除机器类型失败",
      "deleteFailedMissingId": "删除失败：缺少ID",
      "deleteSuccess": "删除机器类型成功",
      "editTypeDialog": "编辑机器类型",
      "help": {
        "configSection": "选择配置区块，用于将配置项分组管理",
        "key": "配置项的键，用于在系统中标识该配置",
        "remark": "机器类型的备注信息，可用于记录该类型的特性或说明",
        "typeCode": "机器类型的唯一编码，建议使用字母或数字组合，创建后不可修改",
        "typeName": "机器类型的显示名称，用于在系统中区分不同类型的机器",
        "value": "配置项的值，对应键的具体设置"
      },
      "keyLabel": "键",
      "loadDataFailed": "加载机器类型数据失败",
      "machineSection": "机器配置",
      "removeConfigItem": "删除配置项",
      "title": "机器类型管理",
      "typeCode": "类型编码",
      "typeCodeLabel": "类型编码",
      "typeName": "类型名称",
      "typeNameLabel": "类型名称",
      "updateFailed": "编辑机器类型失败",
      "updateSuccess": "编辑机器类型成功",
      "valueLabel": "值",
      "viewConfig": "查看配置"
    },
    "mediaResourceManagement": {
      "browserNotSupportVideo": "您的浏览器不支持视频播放",
      "clickUploadOrDrag": "点击上传或拖拽文件到此区域",
      "confirmDeleteMessage": "确定要删除媒体资源 \"{resourceName}\" 吗？",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "editMediaResource": "编辑媒体资源",
      "enterResourceUrl": "请先输入资源URL",
      "help": {
        "resourceDescription": "资源的描述信息，用于说明资源的用途、内容或备注，最大255个字符",
        "resourceName": "资源的显示名称，用于在系统中标识和展示资源，长度不超过100个字符",
        "resourceType": "资源的类型，选择图片或视频，不同类型支持不同的文件格式和大小限制",
        "resourceUrl": "资源的URL地址，可以通过上传文件自动生成，也可以手动输入外部URL链接，最大255个字符"
      },
      "image": "图片",
      "imageLoadFailed": "图片加载失败",
      "imagePreview": "图片预览",
      "imageSizeLimit": "图片大小不能超过 1MB!",
      "loadDataFailed": "加载数据失败",
      "loadFailed": "加载失败",
      "noDescription": "暂无描述",
      "noPreview": "无预览",
      "onlyImageFiles": "只能上传图片文件!",
      "onlyVideoFiles": "只能上传视频文件!",
      "orInputUrl": "或输入URL：",
      "preview": "预览",
      "resourceDescription": "资源描述",
      "resourceName": "资源名称",
      "resourceType": "资源类型",
      "resourceUpload": "资源上传",
      "resourceUrl": "资源URL",
      "searchPlaceholder": "搜索资源名称或描述...",
      "selectResourceType": "选择资源类型",
      "supportFormats": "支持 {formats} 格式，文件大小不超过 {size}",
      "title": "媒体资源管理",
      "unknownResourceType": "未知资源类型",
      "updateSuccess": "更新成功",
      "uploadFailed": "上传失败，请重试",
      "uploadFailedMessage": "{type}上传失败",
      "uploadMediaResource": "上传媒体资源",
      "uploadResource": "上传资源",
      "uploadSuccess": "上传成功",
      "uploadSuccessMessage": "{type}上传成功",
      "video": "视频",
      "videoPreview": "视频预览",
      "videoSizeLimit": "视频大小不能超过 100MB!",
      "videoUrl": "视频URL"
    },
    "menuManagement": {
      "actionUrlLabel": "请求URL",
      "addButton": "新增按钮",
      "addButtonTitle": "新增按钮",
      "addMenu": "新增菜单",
      "addMenuTitle": "新增菜单",
      "belongMenu": "所属菜单",
      "buttonCode": "按钮编码",
      "buttonCodeLabel": "按钮编码",
      "buttonList": "按钮列表",
      "buttonName": "按钮名称",
      "buttonNameLabel": "按钮名称",
      "createFailed": "创建失败",
      "createSuccess": "创建成功",
      "deleteButtonConfirm": "确定要删除按钮 \"{buttonName}\" 吗？",
      "deleteFailed": "删除失败",
      "deleteFailedMissingId": "删除失败：缺少ID",
      "deleteMenuConfirm": "确定要删除菜单 \"{menuName}\" 吗？",
      "deleteSuccess": "删除成功",
      "deleteTitle": "确认删除",
      "editButtonTitle": "编辑按钮",
      "editMenuTitle": "编辑菜单",
      "help": {
        "actionUrl": "按钮对应的后端API接口地址，用于执行按钮对应的操作",
        "belongMenu": "按钮所属的菜单，按钮将显示在该菜单下，用于权限管理和功能组织",
        "buttonCode": "按钮的唯一编码，用于权限控制和API调用，建议使用下划线命名，长度2-128个字符",
        "buttonName": "按钮的显示名称，用于在系统中标识和展示按钮，长度2-60个字符",
        "isHidden": "菜单是否在导航栏中隐藏，隐藏后菜单仍然可以通过URL访问，但不会在导航栏中显示",
        "menuCode": "菜单的唯一编码，用于在系统中标识菜单，建议使用字母、数字和下划线组合，长度2-60个字符",
        "menuIcon": "菜单的图标标识符，使用图标库的图标名称，如 ep:menu、ep:home 等",
        "menuName": "菜单的显示名称，用于在导航栏和系统中展示，长度2-60个字符",
        "menuUrl": "菜单对应的路由路径，用于前端路由跳转，必须以 / 开头",
        "parentMenu": "菜单的上级菜单，用于构建菜单的层级结构，根菜单的上级菜单为空",
        "remarks": "菜单的备注信息，用于记录菜单的用途、说明或其他备注",
        "sort": "菜单的排序序号，数值越小越靠前，范围0-9999",
        "status": "菜单的状态，启用后菜单才会在系统中显示，禁用后菜单将不可见"
      },
      "hidden": "隐藏",
      "isHidden": "是否隐藏",
      "loadButtonDataFailed": "加载按钮数据失败",
      "loadMenuDataFailed": "加载菜单数据失败",
      "menuCode": "菜单编码",
      "menuDisabled": "禁用",
      "menuEnabled": "启用",
      "menuIcon": "菜单图标",
      "menuList": "菜单列表",
      "menuName": "菜单名称",
      "menuUrl": "菜单URL",
      "notHidden": "不隐藏",
      "parentMenu": "上级菜单",
      "requestUrl": "请求URL",
      "searchMenu": "搜索菜单...",
      "selectMenuFirst": "请先选择菜单",
      "sort": "排序",
      "title": "系统菜单管理",
      "updateFailed": "更新失败",
      "updateSuccess": "更新成功"
    },
    "orgTagManagement": {
      "addDialogTitle": "新增机构标签",
      "addTag": "新增标签",
      "deleteConfirm": "确定要删除标签 \"{tagName}\" 吗？",
      "deleteTitle": "确认删除",
      "editDialogTitle": "编辑机构标签",
      "editTag": "编辑标签",
      "searchPlaceholder": "搜索标签名称...",
      "tagName": "标签名称",
      "tagNameLabel": "标签名称",
      "title": "机构标签管理"
    },
    "paymentMethodManagement": {
      "addMethod": "新增支付方式",
      "addMethodDialog": "新增支付方式",
      "addSuccess": "新增支付方式成功",
      "allChannels": "全部渠道",
      "associate": "关联",
      "associateFailed": "关联失败",
      "associateSuccess": "关联成功",
      "associatedChannelProducts": "关联的渠道产品",
      "availableProducts": "可关联的渠道产品",
      "clickUploadLogo": "点击上传Logo",
      "confirmDeleteMethodMessage": "确定要删除支付方式 \"{methodName}\" 吗？删除后将同时删除所有关联关系。",
      "currentMethod": "当前支付方式",
      "deleteFailed": "删除支付方式失败",
      "deleteSuccess": "删除支付方式成功",
      "editMethodDialog": "编辑支付方式",
      "fixedRate": "固定费率",
      "help": {
        "methodCode": "支付方式的唯一编码，用于在系统中标识支付方式，建议使用字母、数字和下划线组合，最大50个字符",
        "methodLogo": "支付方式的Logo图标，支持上传图片文件或使用图标库的图标标识符（如ep:credit-card），建议尺寸40x40px，图片大小不超过2MB",
        "methodName": "支付方式的显示名称，用于在系统中标识和展示支付方式，如支付宝、微信支付等，最大100个字符"
      },
      "imageSizeLimit": "图片大小不能超过 1MB!",
      "loadDataFailed": "加载支付方式数据失败",
      "logoCleared": "Logo已清除",
      "logoHint": "支持图片文件上传，建议尺寸：40x40px",
      "logoLoadFailed": "Logo加载失败",
      "logoUploadFailed": "Logo上传失败",
      "logoUploadSuccess": "Logo上传成功",
      "manageProducts": "管理产品",
      "manageProductsDialog": "管理关联产品",
      "methodCode": "支付方式编码",
      "methodLogo": "支付方式Logo",
      "methodName": "支付方式名称",
      "noAssociations": "暂未关联任何渠道产品，点击\"管理产品\"进行关联",
      "noMethodsDescription": "暂无支付方式数据，点击\"新增\"按钮创建第一个支付方式",
      "onlyImageFiles": "只能上传图片文件!",
      "percentageRate": "百分比费率",
      "removeAssociation": "取消关联",
      "removeAssociationFailed": "取消关联失败",
      "removeAssociationSuccess": "取消关联成功",
      "searchPlaceholder": "搜索支付方式名称或编码...",
      "selectChannelFilter": "选择渠道筛选",
      "title": "支付方式管理",
      "updateSuccess": "更新支付方式成功"
    },
    "paymentProviderManagement": {
      "addChannel": "新增渠道",
      "addChannelDialog": "新增支付渠道",
      "addConfigItem": "添加配置项",
      "addProduct": "添加产品",
      "addProductDialog": "新增渠道产品",
      "addRequiredParam": "添加必填参数",
      "addRequiredParamHint": "点击\"添加必填参数\"开始配置",
      "addSuccess": "添加成功",
      "belongingChannel": "所属渠道",
      "booleanType": "布尔值",
      "channelCode": "渠道编码",
      "channelConfig": "渠道配置",
      "channelConfigLabel": "渠道配置",
      "channelLogo": "渠道Logo",
      "channelName": "渠道名称",
      "channelProducts": "渠道产品",
      "clickAddConfig": "点击\"添加配置项\"开始配置",
      "clickUploadLogo": "点击上传Logo",
      "comfirmDeleteChannelMessage": "确定要删除支付渠道 \"{channelName}\" 吗？删除后将同时删除该渠道下的所有产品。",
      "comfirmDeleteProductMessage": "确定要删除产品 \"{productName}\" 吗？",
      "completeConfigItems": "请完善所有配置项",
      "configAction": "操作",
      "configDetailDialog": "渠道配置详情",
      "configItemManagement": "配置项管理",
      "configKey": "配置键",
      "configKeyCannotBeRepeated": "配置键不能重复",
      "configType": "类型",
      "configValue": "配置值",
      "confirmDeleteChannelMessage": "确定要删除支付渠道 \"{channelName}\" 吗？删除后将同时删除该渠道下的所有产品。",
      "confirmDeleteProductMessage": "确定要删除产品 \"{productName}\" 吗？",
      "deleteFailed": "删除失败",
      "deleteProductFailed": "删除产品失败",
      "deleteSuccess": "删除成功",
      "editChannel": "编辑渠道",
      "editChannelDialog": "编辑支付渠道",
      "editProductDialog": "编辑渠道产品",
      "emailType": "邮箱",
      "fixedAmountRate": "固定金额费率",
      "fixedRate": "固定费率",
      "fixedRateHint": "固定金额费率，例如：0.50 表示每笔交易收取0.50元",
      "formMode": "表单模式",
      "formatJson": "格式化JSON",
      "help": {
        "channelCode": "支付渠道的唯一编码，用于在系统中标识渠道，建议使用字母、数字和下划线组合，最大100个字符",
        "channelConfig": "支付渠道的配置信息，支持表单模式和JSON模式两种编辑方式，用于存储渠道的API密钥、商户号等配置参数",
        "channelLogo": "支付渠道的Logo图标，支持上传图片文件或使用图标库的图标标识符（如ep:credit-card），建议尺寸40x40px，图片大小不超过2MB",
        "channelName": "支付渠道的显示名称，用于在系统中标识和展示渠道，如支付宝、微信支付等，最大100个字符",
        "fixedRate": "产品的固定金额费率，例如输入0.50表示每笔交易收取0.50元，用于计算交易手续费",
        "orgRequiredParams": "定义机构使用此渠道时必须配置的参数，包括参数名称、类型、描述、是否必填和示例值，用于指导机构正确配置渠道参数",
        "percentageRate": "产品的百分比费率，范围0-100，例如输入0.6表示0.6%，1.5表示1.5%，用于计算交易手续费",
        "productCode": "渠道产品的唯一编码，用于在系统中标识产品，建议使用字母、数字和下划线组合，最大100个字符",
        "productName": "渠道产品的显示名称，用于在系统中标识和展示产品，最大100个字符"
      },
      "imageSizeLimit": "图片大小不能超过 1MB!",
      "jsonFormatIncorrect": "JSON格式不正确",
      "jsonMode": "JSON模式",
      "jsonType": "JSON",
      "loadDataFailed": "加载数据失败",
      "logoCleared": "Logo已清除",
      "logoHint": "支持图片文件上传，建议尺寸：40x40px",
      "logoLoadFailed": "Logo加载失败",
      "logoUploadFailed": "Logo上传失败",
      "logoUploadSuccess": "Logo上传成功",
      "noChannelsDescription": "暂无支付渠道数据，点击上方\"新增\"按钮添加第一个支付渠道",
      "noConfigItems": "暂无配置项",
      "noProducts": "暂无产品，点击\"添加产品\"创建",
      "noRequiredParams": "暂无必填参数",
      "numberType": "数字",
      "object": "对象",
      "onlyImageFiles": "只能上传图片文件!",
      "orgRequiredParams": "机构必填参数",
      "orgRequiredParamsConfig": "机构必填参数配置",
      "orgRequiredParamsConfigDesc": "配置机构使用此渠道时必须填写的参数",
      "orgRequiredParamsDesc": "定义机构使用此渠道时必须配置的参数",
      "paramDesc": "参数描述",
      "paramExample": "示例值",
      "paramName": "参数名称",
      "paramRequired": "是否必填",
      "paramType": "参数类型",
      "parseConfigJsonFailed": "解析配置JSON失败",
      "percentageRate": "百分比费率",
      "percentageRateHint": "百分比费率范围：0-100，例如：0.6 表示 0.6%，1.5 表示 1.5%",
      "percentageRateLabel": "百分比费率",
      "productCode": "产品编码",
      "productName": "产品名称",
      "requiredParamAction": "操作",
      "requiredParamDesc": "参数描述",
      "requiredParamExample": "示例值",
      "requiredParamName": "参数名称",
      "requiredParamNameExists": "参数名称已存在",
      "requiredParamRequired": "必填",
      "requiredParamMasked": "是否打码",
      "requiredParamType": "参数类型",
      "requiredParamValidation": "参数名称不能为空",
      "resetConfig": "重置配置",
      "searchPlaceholder": "搜索渠道名称或编码...",
      "stringType": "字符串",
      "submitChannelFailed": "提交渠道失败",
      "submitProductFailed": "提交产品失败",
      "title": "支付渠道管理",
      "updateSuccess": "更新成功",
      "uploadResponseFormatError": "上传响应格式错误",
      "urlType": "URL",
      "validateJson": "验证JSON",
      "viewConfig": "查看配置"
    },
    "permissionGroupManagement": {
      "addPermissionGroup": "新增权限组",
      "addPermissionGroupDialog": "新增权限组",
      "buttonPermissions": "按钮权限",
      "deletePermissionGroupConfirm": "确定要删除权限组 \"{groupName}\" 吗？",
      "editPermissionGroup": "编辑权限组",
      "groupName": "权限组名称",
      "groupNameLabel": "权限组名称",
      "groupType": "权限组类型",
      "groupTypeLabel": "权限组类型",
      "help": {
        "groupName": "权限组的显示名称，用于在系统中标识和展示权限组，长度2-60个字符",
        "groupType": "权限组的类型标识，用于区分不同类型的权限组，如管理员、操作员等",
        "remark": "权限组的备注信息，用于记录权限组的用途、说明或其他备注",
        "status": "权限组的状态，启用后权限组才会生效，禁用后权限组将不可用"
      },
      "loadButtonDataFailed": "加载按钮数据失败",
      "loadMenuDataFailed": "加载菜单数据失败",
      "loadPermissionGroupDataFailed": "加载权限组数据失败",
      "loadPermissionsFailed": "加载权限设置失败",
      "menuPermissions": "菜单权限",
      "noButtonsForMenu": "该菜单暂无按钮权限",
      "permissionGroupList": "权限组列表",
      "permissionSettings": "权限设置",
      "pleaseSelectMenu": "请先选择菜单",
      "pleaseSelectMenuFirst": "请先勾选菜单",
      "savePermissions": "保存权限",
      "savePermissionsFailed": "权限保存失败",
      "savePermissionsSuccess": "权限保存成功",
      "searchPermissionGroup": "搜索权限组...",
      "selectPermissionGroupFirst": "请先选择权限组",
      "statusLabel": "状态",
      "title": "权限组管理"
    },
    "platProductManagement": {
      "addProduct": "新增产品",
      "addProductDialog": "新增平台业务产品",
      "addSuccess": "新增产品成功",
      "associatedChannels": "已关联渠道",
      "availableChannels": "可关联渠道",
      "channelAssociationFailed": "渠道关联失败",
      "channelAssociationSuccess": "渠道关联成功",
      "channelCount": "关联渠道数",
      "channelManagementDialog": "管理产品渠道关联 - {productName}",
      "confirmDeleteProductMessage": "确定要删除产品 \"{productName}\" 吗？删除后将同时删除所有渠道关联。",
      "deleteFailed": "删除产品失败",
      "deleteSuccess": "删除产品成功",
      "editProduct": "编辑产品",
      "editProductDialog": "编辑平台业务产品",
      "enterH5Weburl": "请输入H5业务路径",
      "enterProductCode": "请输入产品编码",
      "enterProductName": "请输入产品名称",
      "enterRemark": "请输入备注",
      "h5Weburl": "H5业务路径",
      "help": {
        "h5Weburl": "H5业务路径，用于H5支付场景的业务URL地址，最大60个字符",
        "productCode": "平台业务产品的唯一编码，用于在系统中标识该产品，创建后不可修改，最大50个字符",
        "productName": "平台业务产品的显示名称，用于在系统中标识和展示产品，最大100个字符",
        "remark": "产品的备注信息，用于记录产品的用途、说明或其他备注，最大256个字符",
        "status": "产品状态，启用后产品才能正常使用，禁用后产品将无法使用"
      },
      "loadAssociatedChannelsFailed": "加载关联渠道失败",
      "loadDataFailed": "加载产品数据失败",
      "manageChannels": "管理渠道",
      "noAssociatedChannels": "暂无关联渠道",
      "noAvailableChannels": "暂无可关联的渠道",
      "noChannelsAvailable": "暂无可关联的渠道",
      "noChannelsSelected": "暂未选择关联渠道",
      "noProductsDescription": "暂无平台业务产品数据，点击\"新增\"按钮创建第一个产品",
      "productCode": "产品编码",
      "productName": "产品名称",
      "relatedChannels": "关联渠道",
      "searchPlaceholder": "搜索产品编码或名称...",
      "selectAtLeastOneChannel": "请选择至少一个渠道",
      "selectChannels": "选择关联渠道",
      "title": "平台业务产品管理",
      "updateSuccess": "更新产品成功"
    },
    "qrCodeTransferLog": {
      "endTime": "结束时间",
      "enterOperatorName": "请输入操作人姓名",
      "loadDataFailed": "加载二维码流转记录失败",
      "loadOrgTreeFailed": "加载机构树失败",
      "noErrorMessage": "无错误信息",
      "operator": "操作人",
      "orgChange": "机构变更",
      "selectEndTime": "选择结束时间",
      "selectStartTime": "选择开始时间",
      "startTime": "开始时间",
      "transferReason": "转移原因",
      "transferResult": "转移结果"
    },
    "qrcodeStickerManagement": {
      "addSticker": "新增贴纸",
      "addStickerDialog": "新增二维码贴纸",
      "batchNo": "转移批次号",
      "bound": "已绑定",
      "confirmDeleteMessage": "确定要删除二维码贴纸 \"{qrNo}\" 吗？",
      "confirmUnbind": "确认解绑",
      "confirmUnbindMessage": "确定要解绑二维码贴纸 \"{qrNo}\" 吗？解绑后状态将变为未绑定。",
      "createBy": "创建人",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "detailSectionAudit": "记录信息",
      "detailSectionDevice": "关联设备",
      "detailSectionMachine": "绑定机器",
      "detailSectionSecurity": "安全信息",
      "deviceType": "设备型号",
      "disabled": "禁用",
      "editStickerDialog": "编辑二维码贴纸",
      "enterQuantity": "请输入生成数量",
      "enterTransferRemark": "请输入转移原因",
      "export": "导出",
      "exportDialog": "导出二维码",
      "fromOrg": "来源机构名称",
      "generateQrCodeFailed": "生成二维码失败",
      "generateSuccess": "成功生成 {quantity} 个二维码贴纸",
      "help": {
        "createBy": "创建人，用于标识二维码贴纸的创建人",
        "createTime": "创建时间，用于标识二维码贴纸的创建时间",
        "deviceType": "设备型号，用于标识绑定的设备型号",
        "machineName": "设备名，用于标识绑定的设备",
        "machineNo": "设备号，用于标识绑定的设备",
        "machineType": "设备类型，用于标识绑定的设备类型",
        "nfcPassword": "NFC密码，用于NFC认证，支持字母和数字，长度4-16个字符",
        "qrCodeImage": "根据链接地址生成的二维码图片，可以保存为PNG格式用于打印或展示",
        "qrCodeUrl": "二维码对应的链接地址，由类型和二维码编号组成，可以复制后用于访问",
        "qrNo": "二维码的唯一编号，由系统自动生成，用于标识和追踪二维码贴纸",
        "quantity": "要生成的二维码贴纸数量，范围1-1000，系统将批量生成指定数量的二维码",
        "remark": "二维码贴纸的备注信息，用于记录用途、说明或其他备注，最大255个字符",
        "serialNumber": "设备序列号，用于标识绑定的设备",
        "status": "二维码贴纸的当前状态，包括未绑定、已绑定和禁用三种状态",
        "toOrgLabel": "选择目标机构，二维码将被转移到该机构下",
        "transferReason": "转移原因，说明二维码转移的理由，最大200个字符",
        "type": "二维码的类型，选择不同的类型将生成不同的链接地址，如收银台、预授权等",
        "updateTime": "更新时间，用于标识二维码贴纸的更新时间"
      },
      "loadDataFailed": "加载数据失败",
      "loadH5UrlOptionsFailed": "加载H5 URL选项失败",
      "loadOrgTreeFailed": "加载机构树失败",
      "loadTransferRecordsFailed": "加载转移记录失败",
      "machineName": "设备名",
      "machineNo": "设备号",
      "machineType": "设备类型",
      "nfcPassword": "NFC密码",
      "noTransferRecords": "暂无转移记录",
      "operateTime": "操作时间",
      "operator": "操作人",
      "orgId": "机构ID",
      "orgName": "机构名称",
      "pleaseSelectQrCode": "请先选择一个二维码贴纸",
      "qrCodeImage": "二维码",
      "qrCodeUrl": "链接地址",
      "qrNo": "二维码编号",
      "qrNoLabel": "二维码编号",
      "quantity": "生成数量",
      "quantityRange": "数量必须在1-1000之间",
      "quantityRequired": "请输入生成数量",
      "saveFailed": "保存失败",
      "saveQrCode": "保存二维码",
      "saveSuccess": "保存成功",
      "searchPlaceholder": "搜索二维码编号或备注...",
      "selectSourceOrg": "请先选择来源机构",
      "selectStatus": "选择状态",
      "selectTargetOrg": "请选择目标机构",
      "selectType": "选择类型",
      "selectTypeFirst": "请先选择类型",
      "serialNumber": "SN",
      "statusLabel": "状态",
      "title": "二维码贴纸管理",
      "toOrg": "目标机构",
      "toOrgLabel": "目标机构",
      "transfer": "转移",
      "transferDialogTitle": "转移二维码贴纸",
      "transferFailed": "二维码转移失败",
      "transferReason": "转移原因",
      "transferRecords": "{qrCode}转移记录",
      "transferSuccess": "二维码转移成功",
      "typeCashier": "收银台",
      "typePreAuth": "预授权",
      "unbind": "解绑",
      "unbindFailed": "解绑失败",
      "unbindSuccess": "解绑成功",
      "unbound": "未绑定",
      "updateSuccess": "更新成功"
    },
    "systemParameterManagement": {
      "addParameter": "新增参数",
      "addParameterDialog": "新增系统参数",
      "addSuccess": "新增成功",
      "confirmDeleteMessage": "确定要删除参数 \"{paramName}\" 吗？",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "editParameter": "编辑参数",
      "editParameterDialog": "编辑系统参数",
      "help": {
        "paramDesc": "系统参数的描述信息，用于说明该参数的用途、说明或其他备注，最大255个字符",
        "paramName": "系统参数的唯一标识名称，用于在系统中引用该参数，创建后不可修改，长度1-100个字符",
        "paramValue": "系统参数的具体值，可以是字符串、数字或其他格式，长度1-255个字符"
      },
      "loadDataFailed": "加载数据失败",
      "paramDesc": "参数描述",
      "paramDescLabel": "参数描述",
      "paramName": "参数名",
      "paramNameLabel": "参数名",
      "paramValue": "参数值",
      "paramValueLabel": "参数值",
      "parameter": "参数",
      "searchPlaceholder": "搜索参数名或描述...",
      "title": "系统参数管理",
      "updateSuccess": "更新成功"
    }
  },
  "timeZoneOptions": {
    "name": {
      "America_Anchorage": "阿拉斯加时间",
      "America_Chicago": "中部时间",
      "America_New_York": "东部时间",
      "Pacific_Honolulu": "夏威夷时间",
      "America_Denver": "山地时间",
      "America_Los_Angeles": "太平洋时间",
      "America_Halifax": "大西洋时间",
      "America_Winnipeg": "中部时间",
      "America_Toronto": "东部时间",
      "America_Edmonton": "山地时间",
      "America_St_Johns": "纽芬兰时间",
      "America_Vancouver": "太平洋时间",
      "America_Mexico_City": "中部标准时间",
      "America_Monterrey": "中部标准时间",
      "America_Cancun": "东部标准时间",
      "America_Hermosillo": "山地标准时间",
      "America_Mazatlan": "山地标准时间",
      "America_Tijuana": "太平洋时间",
      "America_Bogota": "哥伦比亚时间",
      "America_Argentina_Buenos_Aires": "阿根廷时间",
      "Europe_Vienna": "中欧时间",
      "Europe_London": "格林威治标准时间",
      "Asia_Singapore": "新加坡时间",
      "Asia_Shanghai": "中国标准时间"
    },
    "city": {
      "America_Anchorage": "安克雷奇",
      "America_Chicago": "芝加哥",
      "America_New_York": "纽约，华盛顿",
      "Pacific_Honolulu": "火奴鲁鲁",
      "America_Denver": "丹佛",
      "America_Los_Angeles": "洛杉矶",
      "America_Halifax": "哈利法克斯",
      "America_Winnipeg": "温尼伯",
      "America_Toronto": "多伦多",
      "America_Edmonton": "埃德蒙顿",
      "America_St_Johns": "圣约翰斯",
      "America_Vancouver": "温哥华",
      "America_Mexico_City": "墨西哥城",
      "America_Monterrey": "蒙特雷",
      "America_Cancun": "坎昆",
      "America_Hermosillo": "埃莫西约",
      "America_Mazatlan": "马萨特兰",
      "America_Tijuana": "蒂华纳",
      "America_Bogota": "波哥大",
      "America_Argentina_Buenos_Aires": "布宜诺斯艾利斯",
      "Europe_Vienna": "维也纳",
      "Europe_London": "伦敦",
      "Asia_Singapore": "新加坡",
      "Asia_Shanghai": "北京"
    }
  },
  "tagsView": {
    "closeAll": "关闭全部",
    "closeOther": "关闭其他",
    "closeTab": "关闭当前",
    "closeTheLeftTab": "关闭左侧",
    "closeTheRightTab": "关闭右侧",
    "reload": "重新加载"
  }
}
